export default {
  "01": "Crop and animal production, hunting and related service activities",
  "01.1": "Growing of non-perennial crops",
  "01.11": "Growing of cereals (except rice), leguminous crops and oilseeds",
  "01.11Z": "Growing of cereals (except rice), leguminous crops and oilseeds",
  "01.12": "Growing of rice",
  "01.12Z": "Growing of rice",
  "01.13": "Growing of vegetables and melons, roots and tubers",
  "01.13Z": "Growing of vegetables and melons, roots and tubers",
  "01.14": "Growing of sugar cane",
  "01.14Z": "Growing of sugar cane",
  "01.15": "Growing of tobacco",
  "01.15Z": "Growing of tobacco",
  "01.16": "Growing of fibre crops",
  "01.16Z": "Growing of fibre crops",
  "01.19": "Other non-perennial crops",
  "01.19Z": "Other non-perennial crops",
  "01.1A": "Growing of cereals; industrial crops",
  "01.1C": "Growing of vegetables; market gardening",
  "01.1D": "Horticulture; nurseries",
  "01.1F": "Fruit growing",
  "01.1G": "Viticulture",
  "01.2": "Growing of perennial crops",
  "01.21": "Growing of grapes",
  "01.21Z": "Growing of grapes",
  "01.22": "Growing of tropical and subtropical fruits",
  "01.22Z": "Growing of tropical and subtropical fruits",
  "01.23": "Growing of citrus fruits",
  "01.23Z": "Growing of citrus fruits",
  "01.24": "Growing of pome fruits and stone fruits",
  "01.24Z": "Growing of pome fruits and stone fruits",
  "01.25": "Growing of other tree and bush fruits and nuts",
  "01.25Z": "Growing of other tree and bush fruits and nuts",
  "01.26": "Growing of oleaginous fruits",
  "01.26Z": "Growing of oleaginous fruits",
  "01.27": "Growing of beverage crops",
  "01.27Z": "Growing of beverage crops",
  "01.28": "Growing of spice, aromatic, medicinal and pharmaceutical crops",
  "01.28Z": "Growing of spice, aromatic, medicinal and pharmaceutical crops",
  "01.29": "Other perennial crops",
  "01.29Z": "Other perennial crops",
  "01.2A": "Raising of bovine animals",
  "01.2C": "Raising of sheep, goats and equines",
  "01.2E": "Raising of swine",
  "01.2G": "Raising of poultry",
  "01.2J": "Raising of other animals",
  "01.3": "Mixed farming",
  "01.30": "Plant propagation",
  "01.30Z": "Plant propagation",
  "01.3Z": "Mixed farming",
  "01.4": "Animal production",
  "01.41": "Raising of dairy cattle",
  "01.41Z": "Raising of dairy cattle",
  "01.42": "Raising of other bovine animals and buffaloes",
  "01.42Z": "Raising of other bovine animals and buffaloes",
  "01.43": "Raising of horses and other equines",
  "01.43Z": "Raising of horses and other equines",
  "01.44": "Raising of camels and camelids",
  "01.44Z": "Raising of camels and camelids",
  "01.45": "Raising of sheep and goats",
  "01.45Z": "Raising of sheep and goats",
  "01.46": "Raising of swine/pigs",
  "01.46Z": "Raising of swine/pigs",
  "01.47": "Raising of poultry",
  "01.47Z": "Raising of poultry",
  "01.49": "Raising of other animals",
  "01.49Z": "Raising of other animals",
  "01.4A": "Services to crop production",
  "01.4B": "Landscape design and maintenance",
  "01.4D": "Services to animal husbandry",
  "01.5": "Hunting, trapping and related service activities",
  "01.50": "Mixed farming",
  "01.50Z": "Mixed farming",
  "01.5Z": "Hunting",
  "01.6": "Support activities for agriculture and post-harvest crop activities",
  "01.61": "Support activities for crop production",
  "01.61Z": "Support activities for crop production",
  "01.62": "Support activities for animal production",
  "01.62Z": "Support activities for animal production",
  "01.63": "Post-harvest crop activities",
  "01.63Z": "Post-harvest crop activities",
  "01.64": "Seed processing for propagation",
  "01.64Z": "Seed processing for propagation",
  "01.7": "Hunting, trapping and related service activities",
  "01.70": "Hunting, trapping and related service activities",
  "01.70Z": "Hunting, trapping and related service activities",
  "02": "Forestry and logging",
  "02.0": "Forestry, logging, and related services",
  "02.0A": "Silviculture",
  "02.0B": "Logging",
  "02.0D": "Forestry services",
  "02.1": "Silviculture and other forestry activities",
  "02.10": "Silviculture and other forestry activities",
  "02.10Z": "Silviculture and other forestry activities",
  "02.2": "Logging",
  "02.20": "Logging",
  "02.20Z": "Logging",
  "02.3": "Gathering of wild growing non-wood products",
  "02.30": "Gathering of wild growing non-wood products",
  "02.30Z": "Gathering of wild growing non-wood products",
  "02.4": "Support services to forestry",
  "02.40": "Support services to forestry",
  "02.40Z": "Support services to forestry",
  "03": "Fishing and aquaculture",
  "03.1": "Fishing",
  "03.11": "Marine fishing",
  "03.11Z": "Marine fishing",
  "03.12": "Freshwater fishing",
  "03.12Z": "Freshwater fishing",
  "03.2": "Aquaculture",
  "03.21": "Marine aquaculture",
  "03.21Z": "Marine aquaculture",
  "03.22": "Freshwater aquaculture",
  "03.22Z": "Freshwater aquaculture",
  "05": "Mining of coal and lignite",
  "05.0": "Fishing, aquaculture, related services",
  "05.0A": "Fishing",
  "05.0C": "Fish farming, aquaculture",
  "05.1": "Mining of hard coal",
  "05.10": "Mining of hard coal",
  "05.10Z": "Mining of hard coal",
  "05.2": "Mining of lignite",
  "05.20": "Mining of lignite",
  "05.20Z": "Mining of lignite",
  "06": "Extraction of crude petroleum and natural gas",
  "06.1": "Extraction of crude petroleum",
  "06.10": "Extraction of crude petroleum",
  "06.10Z": "Extraction of crude petroleum",
  "06.2": "Extraction of natural gas",
  "06.20": "Extraction of natural gas",
  "06.20Z": "Extraction of natural gas",
  "07": "Mining of metal ores",
  "07.1": "Mining of iron ores",
  "07.10": "Mining of iron ores",
  "07.10Z": "Mining of iron ores",
  "07.2": "Mining of non-ferrous metal ores",
  "07.21": "Mining of uranium and thorium ores",
  "07.21Z": "Mining of uranium and thorium ores",
  "07.29": "Mining of other non-ferrous metal ores",
  "07.29Z": "Mining of other non-ferrous metal ores",
  "08": "Other mining and quarrying",
  "08.1": "Quarrying of stone, sand and clay",
  "08.11": "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate",
  "08.11Z": "Quarrying of ornamental and building stone, limestone, gypsum, chalk and slate",
  "08.12": "Operation of gravel and sand pits; mining of clays and kaolin",
  "08.12Z": "Operation of gravel and sand pits; mining of clays and kaolin",
  "08.9": "Mining and quarrying n.e.c.",
  "08.91": "Mining of chemical and fertiliser minerals",
  "08.91Z": "Mining of chemical and fertiliser minerals",
  "08.92": "Extraction of peat",
  "08.92Z": "Extraction of peat",
  "08.93": "Extraction of salt",
  "08.93Z": "Extraction of salt",
  "08.99": "Other mining and quarrying n.e.c.",
  "08.99Z": "Other mining and quarrying n.e.c.",
  "09": "Support activities for mining and quarrying",
  "09.1": "Support activities for petroleum and natural gas extraction",
  "09.10": "Support activities for petroleum and natural gas extraction",
  "09.10Z": "Support activities for petroleum and natural gas extraction",
  "09.9": "Support activities for other mining and quarrying",
  "09.90": "Support activities for other mining and quarrying",
  "09.90Z": "Support activities for other mining and quarrying",
  "1": "Agriculture, hunting, related services",
  "10": "Manufacture of food products",
  "10.1": "Processing and preserving of meat and production of meat products",
  "10.11": "Processing and preserving of meat",
  "10.11Z": "Processing and preserving of meat",
  "10.12": "Processing and preserving of poultry meat",
  "10.12Z": "Processing and preserving of poultry meat",
  "10.13": "Production of meat products",
  "10.13A": "Industrial preparation of meat products",
  "10.13B": "Delicatessen",
  "10.1Z": "Extraction and agglomeration of hard coal",
  "10.2": "Processing and preserving of fish, crustaceans and molluscs",
  "10.20": "Processing and preserving of fish, crustaceans and molluscs",
  "10.20Z": "Processing and preserving of fish, crustaceans and molluscs",
  "10.2Z": "Extraction and agglomeration of lignite",
  "10.3": "Processing and preserving of fruit and vegetables",
  "10.31": "Processing and preserving of potatoes",
  "10.31Z": "Processing and preserving of potatoes",
  "10.32": "Manufacture of fruit and vegetable juice",
  "10.32Z": "Manufacture of fruit and vegetable juice",
  "10.39": "Other processing and preserving of fruit and vegetables",
  "10.39A": "Other processing and preserving of vegetables",
  "10.39B": "Processing and preserving of fruit",
  "10.3Z": "Extraction and agglomeration of peat",
  "10.4": "Manufacture of vegetable and animal oils and fats",
  "10.41": "Manufacture of oils and fats",
  "10.41A": "Manufacture of crude oils and fats",
  "10.41B": "Manufacture of refined oils and fats",
  "10.42": "Manufacture of margarine and similar edible fats",
  "10.42Z": "Manufacture of margarine and similar edible fats",
  "10.5": "Manufacture of dairy products",
  "10.51": "Operation of dairies and cheese making",
  "10.51A": "Manufacture of liquid milk and fresh products",
  "10.51B": "Manufacture of butter",
  "10.51C": "Manufacture of cheese",
  "10.51D": "Manufacture of other dairy products",
  "10.52": "Manufacture of ice cream",
  "10.52Z": "Manufacture of ice cream",
  "10.6": "Manufacture of grain mill products, starches and starch products",
  "10.61": "Manufacture of grain mill products",
  "10.61A": "Milling",
  "10.61B": "Other grain processing activities",
  "10.62": "Manufacture of starches and starch products",
  "10.62Z": "Manufacture of starches and starch products",
  "10.7": "Manufacture of bakery and macaroni products",
  "10.71": "Manufacture of bread; manufacture of fresh pastry goods and cakes",
  "10.71A": "Industrial manufacture of bread and fresh pastry",
  "10.71B": "Baking of bakery products",
  "10.71C": "Baking and pastry making",
  "10.71D": "Pastry making",
  "10.72": "Manufacture of rusks and biscuits; manufacture of preserved pastry goods and cakes",
  "10.72Z": "Manufacture of rusks and biscuits; manufacture of preserved pastry goods and cakes",
  "10.73": "Manufacture of macaroni, noodles, couscous and similar farinaceous products",
  "10.73Z": "Manufacture of macaroni, noodles, couscous and similar farinaceous products",
  "10.8": "Manufacture of other food products",
  "10.81": "Manufacture of sugar",
  "10.81Z": "Manufacture of sugar",
  "10.82": "Manufacture of cocoa, chocolate and sugar confectionery",
  "10.82Z": "Manufacture of cocoa, chocolate and sugar confectionery",
  "10.83": "Processing of tea and coffee",
  "10.83Z": "Processing of tea and coffee",
  "10.84": "Manufacture of condiments and seasonings",
  "10.84Z": "Manufacture of condiments and seasonings",
  "10.85": "Manufacture of prepared meals and dishes",
  "10.85Z": "Manufacture of prepared meals and dishes",
  "10.86": "Manufacture of homogenized food preparations and dietetic food",
  "10.86Z": "Manufacture of homogenized food preparations and dietetic food",
  "10.89": "Manufacture of other food products n.e.c.",
  "10.89Z": "Manufacture of other food products n.e.c.",
  "10.9": "Manufacture of prepared animal feeds",
  "10.91": "Manufacture of prepared feeds for farm animals",
  "10.91Z": "Manufacture of prepared feeds for farm animals",
  "10.92": "Manufacture of prepared pet foods",
  "10.92Z": "Manufacture of prepared pet foods",
  "11": "Manufacture of beverages",
  "11.0": "Manufacture of beverages",
  "11.01": "Distilling, rectifying and blending of spirits",
  "11.01Z": "Distilling, rectifying and blending of spirits",
  "11.02": "Manufacture of wine from grape",
  "11.02A": "Manufacture of sparkling wines",
  "11.02B": "Wine making",
  "11.03": "Manufacture of cider and other fruit wines",
  "11.03Z": "Manufacture of cider and other fruit wines",
  "11.04": "Manufacture of other non-distilled fermented beverages",
  "11.04Z": "Manufacture of other non-distilled fermented beverages",
  "11.05": "Manufacture of beer",
  "11.05Z": "Manufacture of beer",
  "11.06": "Manufacture of malt",
  "11.06Z": "Manufacture of malt",
  "11.07": "Manufacture of soft drinks; production of mineral waters and other bottled waters",
  "11.07A": "Manufacture of table waters",
  "11.07B": "Production of soft drinks",
  "11.1": "Extraction of crude petroleum and natural gas",
  "11.1Z": "Extraction of crude petroleum and natural gas",
  "11.2": "Support activities for petroleum and natural gas extraction",
  "11.2Z": "Support activities for petroleum and natural gas extraction",
  "12": "Manufacture of tobacco products",
  "12.0": "Mining of uranium and thorium ores",
  "12.00": "Manufacture of tobacco products",
  "12.00Z": "Manufacture of tobacco products",
  "12.0Z": "Mining of uranium and thorium ores",
  "13": "Manufacture of textiles",
  "13.1": "Preparation and spinning of textile fibres",
  "13.10": "Preparation and spinning of textile fibres",
  "13.10Z": "Preparation and spinning of textile fibres",
  "13.1Z": "Mining of iron ores",
  "13.2": "Weaving of textiles",
  "13.20": "Weaving of textiles",
  "13.20Z": "Weaving of textiles",
  "13.2Z": "Mining of non-ferrous metal ores",
  "13.3": "Finishing of textiles",
  "13.30": "Finishing of textiles",
  "13.30Z": "Finishing of textiles",
  "13.9": "Manufacture of other textiles",
  "13.91": "Manufacture of knitted and crocheted fabrics",
  "13.91Z": "Manufacture of knitted and crocheted fabrics",
  "13.92": "Manufacture of made-up textile articles, except apparel",
  "13.92Z": "Manufacture of made-up textile articles, except apparel",
  "13.93": "Manufacture of carpets and rugs",
  "13.93Z": "Manufacture of carpets and rugs",
  "13.94": "Manufacture of cordage, rope, twine and netting",
  "13.94Z": "Manufacture of cordage, rope, twine and netting",
  "13.95": "Manufacture of non-wovens and articles made from non-wovens, except apparel",
  "13.95Z": "Manufacture of non-wovens and articles made from non-wovens, except apparel",
  "13.96": "Manufacture of other technical and industrial textiles",
  "13.96Z": "Manufacture of other technical and industrial textiles",
  "13.99": "Manufacture of other textiles n.e.c.",
  "13.99Z": "Manufacture of other textiles n.e.c.",
  "14": "Manufacture of wearing apparel",
  "14.1": "Manufacture of wearing apparel, except fur apparel",
  "14.11": "Manufacture of leather clothes",
  "14.11Z": "Manufacture of leather clothes",
  "14.12": "Manufacture of workwear",
  "14.12Z": "Manufacture of workwear",
  "14.13": "Manufacture of other outerwear",
  "14.13Z": "Manufacture of other outerwear",
  "14.14": "Manufacture of underwear",
  "14.14Z": "Manufacture of underwear",
  "14.19": "Manufacture of other wearing apparel and accessories",
  "14.19Z": "Manufacture of other wearing apparel and accessories",
  "14.1A": "Extraction of ornamental and building stone",
  "14.1C": "Extraction of industrial limestone, gypsum and chalk",
  "14.1E": "Extraction of slate",
  "14.2": "Manufacture of articles of fur",
  "14.20": "Manufacture of articles of fur",
  "14.20Z": "Manufacture of articles of fur",
  "14.2A": "Production of sand and aggregates",
  "14.2C": "Extraction of clays and kaolin",
  "14.3": "Manufacture of knitted and crocheted apparel",
  "14.31": "Manufacture of knitted and crocheted hosiery",
  "14.31Z": "Manufacture of knitted and crocheted hosiery",
  "14.39": "Manufacture of other knitted and crocheted apparel",
  "14.39Z": "Manufacture of other knitted and crocheted apparel",
  "14.3Z": "Extraction of minerals for chemical industry and natural fertilizers",
  "14.4": "Extraction of salt",
  "14.4Z": "Extraction of salt",
  "14.5": "Mining and quarrying n.c.a.",
  "14.5Z": "Mining and quarrying n.c.a.",
  "15": "Manufacture of leather and related products",
  "15.1": "Tanning and dressing of leather; manufacture of luggage, handbags, saddlery and harness; dressing and dyeing of fur",
  "15.11": "Tanning and dressing of leather; dressing and dyeing of fur",
  "15.11Z": "Tanning and dressing of leather; dressing and dyeing of fur",
  "15.12": "Manufacture of luggage, handbags and saddlery",
  "15.12Z": "Manufacture of luggage, handbags and saddlery",
  "15.1A": "Production of red meat",
  "15.1C": "Production of poultry meat",
  "15.1E": "Industrial preparation of meat products",
  "15.1F": "Charcuterie",
  "15.2": "Manufacture of footwear",
  "15.20": "Manufacture of footwear",
  "15.20Z": "Manufacture of footwear",
  "15.2Z": "Fish industry",
  "15.3": "Processing and preserving of fruit and vegetables",
  "15.3A": "Processing and preserving of potatoes",
  "15.3C": "Manufacture of fruit and vegetable juice",
  "15.3E": "Processing and preserving of vegetables",
  "15.3F": "Processing and preserving of fruit",
  "15.4": "Manufacture of oils and fats",
  "15.4A": "Manufacture of crude oils and fats",
  "15.4C": "Manufacture of refined oils and fats",
  "15.4E": "Manufacture of margarine",
  "15.5": "Manufacture of dairy products",
  "15.5A": "Manufacture of liquid milk and fresh products",
  "15.5B": "Manufacture of butter",
  "15.5C": "Manufacture of cheese",
  "15.5D": "Manufacture of other dairy products",
  "15.5F": "Manufacture of ice cream",
  "15.6": "Manufacture of grain mill products, starches and starch products",
  "15.6A": "Milling",
  "15.6B": "Other grain processing activities",
  "15.6D": "Manufacture of starch products",
  "15.7": "Manufacture of prepared animal feeds",
  "15.7A": "Manufacture of prepared feeds for farm animals",
  "15.7C": "Manufacture of prepared pet foods",
  "15.8": "Manufacture of other food products",
  "15.8A": "Industrial manufacture of bread and fresh pastry",
  "15.8B": "Baking of bakery products",
  "15.8C": "Baking and pastry making",
  "15.8D": "Pastry making",
  "15.8F": "Manufacture of rusks, biscuits, preserved pastry goods and cakes",
  "15.8H": "Manufacture of sugar",
  "15.8K": "Manufacture of chocolate and confectionery",
  "15.8M": "Manufacture of pasta",
  "15.8P": "Processing of tea and coffee",
  "15.8R": "Manufacture of condiments and seasonings",
  "15.8T": "Manufacture of prepared meals and dietetic foods for infants",
  "15.8V": "Food industries n.c.a.",
  "15.9": "Manufacture of beverages",
  "15.9A": "Production of natural brandies",
  "15.9B": "Manufacture of spirits",
  "15.9D": "Production of ethyl alcohol by fermentation",
  "15.9F": "Champagne production",
  "15.9G": "Wine making",
  "15.9J": "Cider production",
  "15.9L": "Production of other fermented beverages",
  "15.9N": "Brewing",
  "15.9Q": "Manufacture of malt",
  "15.9S": "Manufacture of bottled waters",
  "15.9T": "Production of soft drinks",
  "16": "Manufacture of wood and of products of wood and cork, except furniture; manufacture of articles of straw and plaiting materials",
  "16.0": "Tobacco industry",
  "16.0Z": "Tobacco industry",
  "16.1": "Sawmilling and planing of wood",
  "16.10": "Sawmilling and planing of wood",
  "16.10A": "Sawmilling and planing of wood, except impregnation",
  "16.10B": "Impregnation of wood",
  "16.2": "Manufacture of products of wood, cork, straw and plaiting materials",
  "16.21": "Manufacture of veneer sheets and wood-based panels",
  "16.21Z": "Manufacture of veneer sheets and wood-based panels",
  "16.22": "Manufacture of assembled parquet floors",
  "16.22Z": "Manufacture of assembled parquet floors",
  "16.23": "Manufacture of other builders' carpentry and joinery",
  "16.23Z": "Manufacture of other builders' carpentry and joinery",
  "16.24": "Manufacture of wooden containers",
  "16.24Z": "Manufacture of wooden containers",
  "16.29": "Manufacture of other products of wood; manufacture of articles of cork, straw and plaiting materials",
  "16.29Z": "Manufacture of other products of wood; manufacture of articles of cork, straw and plaiting materials",
  "17": "Manufacture of paper and paper products",
  "17.1": "Manufacture of pulp, paper and paperboard",
  "17.11": "Manufacture of pulp",
  "17.11Z": "Manufacture of pulp",
  "17.12": "Manufacture of paper and paperboard",
  "17.12Z": "Manufacture of paper and paperboard",
  "17.1A": "Cotton spinning",
  "17.1C": "Wool spinning - carded cycle",
  "17.1E": "Preparation of wool",
  "17.1F": "Wool spinning - combed cycle",
  "17.1H": "Preparation and spinning of flax",
  "17.1K": "Throwing, texturing and winding of silk and artificial or synthetic textiles",
  "17.1M": "Manufacture of sewing thread",
  "17.1P": "Preparation and spinning of other fibres",
  "17.2": "Manufacture of paper and paperboard articles",
  "17.21": "Manufacture of corrugated paper and paperboard and of containers of paper and paperboard",
  "17.21A": "Manufacture of corrugated cardboard",
  "17.21B": "Manufacture of paperboard articles",
  "17.21C": "Manufacture of paper packaging",
  "17.22": "Manufacture of household and sanitary goods and of toilet requisites",
  "17.22Z": "Manufacture of household and sanitary goods and of toilet requisites",
  "17.23": "Manufacture of paper stationery",
  "17.23Z": "Manufacture of paper stationery",
  "17.24": "Manufacture of wallpaper",
  "17.24Z": "Manufacture of wallpaper",
  "17.29": "Manufacture of other articles of paper and paperboard n.e.c.",
  "17.29Z": "Manufacture of other articles of paper and paperboard n.e.c.",
  "17.2A": "Cotton weaving",
  "17.2C": "Wool weaving - carded cycle",
  "17.2E": "Wool weaving - combed cycle",
  "17.2G": "Silk weaving",
  "17.2J": "Weaving of other textiles",
  "17.3": "Finishing of textiles",
  "17.3Z": "Finishing of textiles",
  "17.4": "Manufacture of made-up textile articles, except apparel",
  "17.4A": "Manufacture of household linen and furnishing articles",
  "17.4B": "Manufacture of small textile bedding articles",
  "17.4C": "Manufacture of other made-up textile articles",
  "17.5": "Other textile industries",
  "17.5A": "Manufacture of carpets and rugs",
  "17.5C": "Manufacture of twine, cordage, rope and nets",
  "17.5E": "Manufacture of non-wovens",
  "17.5G": "Textile industries n.c.a.",
  "17.6": "Manufacture of knitted and crocheted fabrics",
  "17.6Z": "Manufacture of knitted and crocheted fabrics",
  "17.7": "Manufacture of knitted and crocheted apparel",
  "17.7A": "Manufacture of hosiery",
  "17.7C": "Manufacture of pullovers and similar articles",
  "18": "Printing and reproduction of recorded media",
  "18.1": "Printing",
  "18.11": "Printing of newspapers",
  "18.11Z": "Printing of newspapers",
  "18.12": "Other printing n.e.c.",
  "18.12Z": "Other printing n.e.c.",
  "18.13": "Pre-press activities",
  "18.13Z": "Pre-press activities",
  "18.14": "Binding and related services",
  "18.14Z": "Binding and related services",
  "18.1Z": "Manufacture of leather clothing",
  "18.2": "Reproduction of recorded media",
  "18.20": "Reproduction of recorded media",
  "18.20Z": "Reproduction of recorded media",
  "18.2A": "Manufacture of workwear",
  "18.2C": "Manufacture of tailor-made clothing",
  "18.2D": "Manufacture of men's and boys' outerwear",
  "18.2E": "Manufacture of women's and girls' outerwear",
  "18.2G": "Manufacture of underwear",
  "18.2J": "Manufacture of other clothing and accessories",
  "18.3": "Dressing and dyeing of fur",
  "18.3Z": "Dressing and dyeing of fur",
  "19": "Manufacture of coke and refined petroleum products",
  "19.1": "Manufacture of coke oven products",
  "19.10": "Manufacture of coke oven products",
  "19.10Z": "Manufacture of coke oven products",
  "19.1Z": "Tanning and dressing of leather",
  "19.2": "Manufacture of refined petroleum products",
  "19.20": "Manufacture of refined petroleum products",
  "19.20Z": "Manufacture of refined petroleum products",
  "19.2Z": "Manufacture of luggage and leather goods",
  "19.3": "Manufacture of footwear",
  "19.3Z": "Manufacture of footwear",
  "2": "Silviculture, logging, related services",
  "20": "Manufacture of chemicals and chemical products",
  "20.1": "Manufacture of basic chemicals, fertilisers and nitrogen compounds, plastics and synthetic rubber in primary forms",
  "20.11": "Manufacture of industrial gases",
  "20.11Z": "Manufacture of industrial gases",
  "20.12": "Manufacture of dyes and pigments",
  "20.12Z": "Manufacture of dyes and pigments",
  "20.13": "Manufacture of other basic inorganic chemicals",
  "20.13A": "Enrichment and reprocessing of nuclear materials",
  "20.13B": "Manufacture of other basic inorganic chemicals n.e.c.",
  "20.14": "Manufacture of other basic organic chemicals",
  "20.14Z": "Manufacture of other basic organic chemicals",
  "20.15": "Manufacture of fertilisers and nitrogen compounds",
  "20.15Z": "Manufacture of fertilisers and nitrogen compounds",
  "20.16": "Manufacture of plastics in primary forms",
  "20.16Z": "Manufacture of plastics in primary forms",
  "20.17": "Manufacture of synthetic rubber in primary forms",
  "20.17Z": "Manufacture of synthetic rubber in primary forms",
  "20.1A": "Sawmilling and planing of wood",
  "20.1B": "Wood impregnation",
  "20.2": "Manufacture of pesticides and other agrochemical products",
  "20.20": "Manufacture of pesticides and other agrochemical products",
  "20.20Z": "Manufacture of pesticides and other agrochemical products",
  "20.2Z": "Manufacture of wood-based panels",
  "20.3": "Manufacture of paints, varnishes and similar coatings, printing ink and mastics",
  "20.30": "Manufacture of paints, varnishes and similar coatings, printing ink and mastics",
  "20.30Z": "Manufacture of paints, varnishes and similar coatings, printing ink and mastics",
  "20.3Z": "Manufacture of wooden frameworks and joinery",
  "20.4": "Manufacture of soap and detergents, cleaning and polishing preparations, perfumes and toilet preparations",
  "20.41": "Manufacture of soap and detergents, cleaning and polishing preparations",
  "20.41Z": "Manufacture of soap and detergents, cleaning and polishing preparations",
  "20.42": "Manufacture of perfumes and toilet preparations",
  "20.42Z": "Manufacture of perfumes and toilet preparations",
  "20.4Z": "Manufacture of wooden packaging",
  "20.5": "Manufacture of other chemical products",
  "20.51": "Manufacture of explosives",
  "20.51Z": "Manufacture of explosives",
  "20.52": "Manufacture of glues",
  "20.52Z": "Manufacture of glues",
  "20.53": "Manufacture of essential oils",
  "20.53Z": "Manufacture of essential oils",
  "20.59": "Manufacture of other chemical products n.e.c.",
  "20.59Z": "Manufacture of other chemical products n.e.c.",
  "20.5A": "Manufacture of various wooden articles",
  "20.5C": "Manufacture of articles of cork, wicker or basketry",
  "20.6": "Manufacture of man-made fibres",
  "20.60": "Manufacture of man-made fibres",
  "20.60Z": "Manufacture of man-made fibres",
  "21": "Manufacture of basic pharmaceutical products and pharmaceutical preparations",
  "21.1": "Manufacture of basic pharmaceutical products",
  "21.10": "Manufacture of basic pharmaceutical products",
  "21.10Z": "Manufacture of basic pharmaceutical products",
  "21.1A": "Manufacture of pulp",
  "21.1C": "Manufacture of paper and paperboard",
  "21.2": "Manufacture of pharmaceutical preparations",
  "21.20": "Manufacture of pharmaceutical preparations",
  "21.20Z": "Manufacture of pharmaceutical preparations",
  "21.2A": "Corrugated cardboard industry",
  "21.2B": "Manufacture of cardboard articles",
  "21.2C": "Manufacture of paper packaging",
  "21.2E": "Manufacture of household and sanitary paper products",
  "21.2G": "Manufacture of stationery",
  "21.2J": "Manufacture of wallpaper",
  "21.2L": "Manufacture of other articles of paper or cardboard",
  "22": "Manufacture of rubber and plastic products",
  "22.1": "Manufacture of rubber products",
  "22.11": "Manufacture of rubber tyres and tubes; retreading and rebuilding of rubber tyres",
  "22.11Z": "Manufacture of rubber tyres and tubes; retreading and rebuilding of rubber tyres",
  "22.19": "Manufacture of other rubber products",
  "22.19Z": "Manufacture of other rubber products",
  "22.1A": "Book publishing",
  "22.1C": "Newspaper publishing",
  "22.1E": "Publishing of journals and periodicals",
  "22.1G": "Sound recording publishing",
  "22.1J": "Other publishing activities",
  "22.2": "Manufacture of plastic products",
  "22.21": "Manufacture of plastic plates, sheets, tubes and profiles",
  "22.21Z": "Manufacture of plastic plates, sheets, tubes and profiles",
  "22.22": "Manufacture of plastic packing goods",
  "22.22Z": "Manufacture of plastic packing goods",
  "22.23": "Manufacture of plastics products for construction",
  "22.23Z": "Manufacture of plastics products for construction",
  "22.29": "Manufacture of other plastic products",
  "22.29A": "Manufacture of technical parts based on plastic materials",
  "22.29B": "Manufacture of everyday plastic products",
  "22.2A": "Newspaper printing",
  "22.2C": "Other printing (job printing)",
  "22.2E": "Bookbinding",
  "22.2G": "Pre-press activities",
  "22.2J": "Auxiliary graphic activities",
  "22.3": "Reproduction of recorded media",
  "22.3A": "Reproduction of sound recordings",
  "22.3C": "Reproduction of video recordings",
  "22.3E": "Reproduction of computer recordings",
  "23": "Manufacture of other non-metallic mineral products",
  "23.1": "Manufacture of glass and glass products",
  "23.11": "Manufacture of flat glass",
  "23.11Z": "Manufacture of flat glass",
  "23.12": "Shaping and processing of flat glass",
  "23.12Z": "Shaping and processing of flat glass",
  "23.13": "Manufacture of hollow glass",
  "23.13Z": "Manufacture of hollow glass",
  "23.14": "Manufacture of glass fibres",
  "23.14Z": "Manufacture of glass fibres",
  "23.19": "Manufacture and processing of other glass, including technical glassware",
  "23.19Z": "Manufacture and processing of other glass, including technical glassware",
  "23.1Z": "Coking",
  "23.2": "Manufacture of refractory products",
  "23.20": "Manufacture of refractory products",
  "23.20Z": "Manufacture of refractory products",
  "23.2Z": "Refining of petroleum",
  "23.3": "Manufacture of ceramic tiles and slabs",
  "23.31": "Manufacture of ceramic tiles and slabs",
  "23.31Z": "Manufacture of ceramic tiles and slabs",
  "23.32": "Manufacture of bricks, tiles and construction products, in baked clay",
  "23.32Z": "Manufacture of bricks, tiles and construction products, in baked clay",
  "23.3Z": "Processing of nuclear materials",
  "23.4": "Manufacture of other ceramic and porcelain products",
  "23.41": "Manufacture of ceramic household and ornamental articles",
  "23.41Z": "Manufacture of ceramic household and ornamental articles",
  "23.42": "Manufacture of ceramic sanitary fixtures",
  "23.42Z": "Manufacture of ceramic sanitary fixtures",
  "23.43": "Manufacture of ceramic insulators and insulating fittings",
  "23.43Z": "Manufacture of ceramic insulators and insulating fittings",
  "23.44": "Manufacture of other technical ceramic products",
  "23.44Z": "Manufacture of other technical ceramic products",
  "23.49": "Manufacture of other ceramic products n.e.c.",
  "23.49Z": "Manufacture of other ceramic products n.e.c.",
  "23.5": "Manufacture of cement, lime and plaster",
  "23.51": "Manufacture of cement",
  "23.51Z": "Manufacture of cement",
  "23.52": "Manufacture of lime and plaster",
  "23.52Z": "Manufacture of lime and plaster",
  "23.6": "Manufacture of articles of concrete, cement and plaster",
  "23.61": "Manufacture of concrete products for construction purposes",
  "23.61Z": "Manufacture of concrete products for construction purposes",
  "23.62": "Manufacture of plaster products for construction purposes",
  "23.62Z": "Manufacture of plaster products for construction purposes",
  "23.63": "Manufacture of ready-mixed concrete",
  "23.63Z": "Manufacture of ready-mixed concrete",
  "23.64": "Manufacture of mortars",
  "23.64Z": "Manufacture of mortars",
  "23.65": "Manufacture of fibre cement",
  "23.65Z": "Manufacture of fibre cement",
  "23.69": "Manufacture of other articles of concrete, plaster and cement",
  "23.69Z": "Manufacture of other articles of concrete, plaster and cement",
  "23.7": "Cutting, shaping and finishing of stone",
  "23.70": "Cutting, shaping and finishing of stone",
  "23.70Z": "Cutting, shaping and finishing of stone",
  "23.9": "Manufacture of abrasive products and other non-metallic mineral products n.e.c.",
  "23.91": "Manufacture of abrasive products",
  "23.91Z": "Manufacture of abrasive products",
  "23.99": "Manufacture of other non-metallic mineral products n.e.c.",
  "23.99Z": "Manufacture of other non-metallic mineral products n.e.c.",
  "24": "Manufacture of basic metals",
  "24.1": "Manufacture of basic iron and steel and of ferro-alloys",
  "24.10": "Manufacture of basic iron and steel and of ferro-alloys",
  "24.10Z": "Manufacture of basic iron and steel and of ferro-alloys",
  "24.1A": "Manufacture of industrial gases",
  "24.1C": "Manufacture of dyes and pigments",
  "24.1E": "Manufacture of other basic inorganic chemicals",
  "24.1G": "Manufacture of other basic organic chemicals",
  "24.1J": "Manufacture of nitrogen products and fertilizers",
  "24.1L": "Manufacture of basic plastics",
  "24.1N": "Manufacture of synthetic rubber",
  "24.2": "Manufacture of tubes, pipes, hollow profiles and related fittings, of steel",
  "24.20": "Manufacture of tubes, pipes, hollow profiles and related fittings, of steel",
  "24.20Z": "Manufacture of tubes, pipes, hollow profiles and related fittings, of steel",
  "24.2Z": "Manufacture of agrochemical products",
  "24.3": "Cold drawing of bars",
  "24.31": "Cold drawing of bars",
  "24.31Z": "Cold drawing of bars",
  "24.32": "Cold rolling of narrow strip",
  "24.32Z": "Cold rolling of narrow strip",
  "24.33": "Cold forming or folding",
  "24.33Z": "Cold forming or folding",
  "24.34": "Cold drawing of wire",
  "24.34Z": "Cold drawing of wire",
  "24.3Z": "Manufacture of paints and varnishes",
  "24.4": "Manufacture of basic precious and other non-ferrous metals",
  "24.41": "Manufacture of basic precious metals",
  "24.41Z": "Manufacture of basic precious metals",
  "24.42": "Aluminium production",
  "24.42Z": "Aluminium production",
  "24.43": "Lead, zinc and tin production",
  "24.43Z": "Lead, zinc and tin production",
  "24.44": "Copper production",
  "24.44Z": "Copper production",
  "24.45": "Other non-ferrous metal production",
  "24.45Z": "Other non-ferrous metal production",
  "24.46": "Processing of nuclear fuel",
  "24.46Z": "Processing of nuclear fuel",
  "24.4A": "Manufacture of basic pharmaceutical products",
  "24.4C": "Manufacture of medicines",
  "24.4D": "Manufacture of other pharmaceutical products",
  "24.5": "Casting of metals",
  "24.51": "Casting of iron",
  "24.51Z": "Casting of iron",
  "24.52": "Casting of steel",
  "24.52Z": "Casting of steel",
  "24.53": "Casting of light metals",
  "24.53Z": "Casting of light metals",
  "24.54": "Casting of other non-ferrous metals",
  "24.54Z": "Casting of other non-ferrous metals",
  "24.5A": "Manufacture of soaps, detergents and cleaning preparations",
  "24.5C": "Manufacture of perfumes and toilet preparations",
  "24.6": "Manufacture of other chemical products",
  "24.6A": "Manufacture of explosives",
  "24.6C": "Manufacture of glues and gelatins",
  "24.6E": "Manufacture of essential oils",
  "24.6G": "Manufacture of chemical products for photography",
  "24.6J": "Manufacture of data media",
  "24.6L": "Manufacture of industrial chemical products",
  "24.7": "Manufacture of man-made fibres",
  "24.7Z": "Manufacture of man-made fibres",
  "25": "Manufacture of fabricated metal products, except machinery and equipment",
  "25.1": "Manufacture of structural metal products, tanks, reservoirs and containers",
  "25.11": "Manufacture of fabricated structural metal products",
  "25.11Z": "Manufacture of fabricated structural metal products",
  "25.12": "Manufacture of doors and windows of metal",
  "25.12Z": "Manufacture of doors and windows of metal",
  "25.1A": "Manufacture of tyres",
  "25.1C": "Retreading of tyres",
  "25.1E": "Manufacture of other rubber products",
  "25.2": "Manufacture of tanks, reservoirs and containers of metal; manufacture of central heating radiators and boilers",
  "25.21": "Manufacture of central heating radiators and boilers",
  "25.21Z": "Manufacture of central heating radiators and boilers",
  "25.29": "Manufacture of other tanks, reservoirs and containers of metal",
  "25.29Z": "Manufacture of other tanks, reservoirs and containers of metal",
  "25.2A": "Manufacture of plastic plates, sheets, tubes and profiles",
  "25.2C": "Manufacture of plastic packaging",
  "25.2E": "Manufacture of plastic elements for construction",
  "25.2G": "Manufacture of various plastic articles",
  "25.2H": "Manufacture of technical plastic parts",
  "25.3": "Manufacture of steam generators, except central heating hot water boilers",
  "25.30": "Manufacture of steam generators, except central heating hot water boilers",
  "25.30Z": "Manufacture of steam generators, except central heating hot water boilers",
  "25.4": "Manufacture of weapons and ammunition",
  "25.40": "Manufacture of weapons and ammunition",
  "25.40Z": "Manufacture of weapons and ammunition",
  "25.5": "Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
  "25.50": "Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
  "25.50A": "Forging, stamping, die-stamping; powder metallurgy",
  "25.50B": "Cutting, stamping",
  "25.6": "Treatment and coating of metals; machining",
  "25.61": "Treatment and coating of metals",
  "25.61Z": "Treatment and coating of metals",
  "25.62": "Machining",
  "25.62A": "Turning",
  "25.62B": "Industrial mechanics",
  "25.7": "Manufacture of cutlery, tools and general hardware",
  "25.71": "Manufacture of cutlery",
  "25.71Z": "Manufacture of cutlery",
  "25.72": "Manufacture of locks and hinges",
  "25.72Z": "Manufacture of locks and hinges",
  "25.73": "Manufacture of tools",
  "25.73A": "Manufacture of molds and models",
  "25.73B": "Manufacture of other tools",
  "25.9": "Manufacture of other fabricated metal products",
  "25.91": "Manufacture of steel drums and similar containers",
  "25.91Z": "Manufacture of steel drums and similar containers",
  "25.92": "Manufacture of light metal packaging",
  "25.92Z": "Manufacture of light metal packaging",
  "25.93": "Manufacture of wire products, chain and springs",
  "25.93Z": "Manufacture of wire products, chain and springs",
  "25.94": "Manufacture of fasteners and screw machine products",
  "25.94Z": "Manufacture of fasteners and screw machine products",
  "25.99": "Manufacture of other fabricated metal products n.e.c.",
  "25.99A": "Manufacture of household metal articles",
  "25.99B": "Manufacture of other metal articles",
  "26": "Manufacture of computer, electronic and optical products",
  "26.1": "Manufacture of electronic components and boards",
  "26.11": "Manufacture of electronic components",
  "26.11Z": "Manufacture of electronic components",
  "26.12": "Manufacture of loaded electronic boards",
  "26.12Z": "Manufacture of loaded electronic boards",
  "26.1A": "Manufacture of flat glass",
  "26.1C": "Shaping and processing of flat glass",
  "26.1E": "Manufacture of hollow glass",
  "26.1G": "Manufacture of glass fibres",
  "26.1J": "Manufacture and processing of technical glass articles",
  "26.1K": "Manufacture of glass insulators",
  "26.2": "Manufacture of computers and peripheral equipment",
  "26.20": "Manufacture of computers and peripheral equipment",
  "26.20Z": "Manufacture of computers and peripheral equipment",
  "26.2A": "Manufacture of ceramic household and ornamental articles",
  "26.2C": "Manufacture of ceramic sanitary fixtures",
  "26.2E": "Manufacture of ceramic insulators and insulating parts",
  "26.2G": "Manufacture of other technical ceramic products",
  "26.2J": "Manufacture of other ceramic products",
  "26.2L": "Manufacture of refractory ceramic products",
  "26.3": "Manufacture of communication equipment",
  "26.30": "Manufacture of communication equipment",
  "26.30Z": "Manufacture of communication equipment",
  "26.3Z": "Manufacture of ceramic tiles",
  "26.4": "Manufacture of consumer electronics",
  "26.40": "Manufacture of consumer electronics",
  "26.40Z": "Manufacture of consumer electronics",
  "26.4A": "Manufacture of bricks",
  "26.4B": "Manufacture of tiles",
  "26.4C": "Manufacture of various terracotta products",
  "26.5": "Manufacture of measuring, testing and navigating equipment; watches and clocks",
  "26.51": "Manufacture of measuring, testing and navigating equipment",
  "26.51A": "Manufacture of navigation aids",
  "26.51B": "Manufacture of scientific and technical instrumentation",
  "26.52": "Manufacture of watches and clocks",
  "26.52Z": "Manufacture of watches and clocks",
  "26.5A": "Manufacture of cement",
  "26.5C": "Manufacture of lime",
  "26.5E": "Manufacture of plaster",
  "26.6": "Manufacture of irradiation, electromedical and electrotherapeutic equipment",
  "26.60": "Manufacture of irradiation, electromedical and electrotherapeutic equipment",
  "26.60Z": "Manufacture of irradiation, electromedical and electrotherapeutic equipment",
  "26.6A": "Manufacture of concrete elements for construction",
  "26.6C": "Manufacture of plaster elements for construction",
  "26.6E": "Manufacture of ready-mixed concrete",
  "26.6G": "Manufacture of dry mortars and concretes",
  "26.6J": "Manufacture of fibre-cement articles",
  "26.6L": "Manufacture of other concrete or plaster articles",
  "26.7": "Manufacture of optical instruments and photographic equipment",
  "26.70": "Manufacture of optical instruments and photographic equipment",
  "26.70Z": "Manufacture of optical instruments and photographic equipment",
  "26.7Z": "Cutting, shaping and finishing of ornamental and building stone",
  "26.8": "Manufacture of magnetic and optical media",
  "26.80": "Manufacture of magnetic and optical media",
  "26.80Z": "Manufacture of magnetic and optical media",
  "26.8A": "Manufacture of abrasive products",
  "26.8C": "Manufacture of non-metallic mineral products n.e.c.",
  "27": "Manufacture of electrical equipment",
  "27.1": "Manufacture of electric motors, generators, transformers and electricity distribution and control apparatus",
  "27.11": "Manufacture of electric motors, generators and transformers",
  "27.11Z": "Manufacture of electric motors, generators and transformers",
  "27.12": "Manufacture of electricity distribution and control apparatus",
  "27.12Z": "Manufacture of electricity distribution and control apparatus",
  "27.1Y": "Iron and steel industry",
  "27.2": "Manufacture of batteries and accumulators",
  "27.20": "Manufacture of batteries and accumulators",
  "27.20Z": "Manufacture of batteries and accumulators",
  "27.2A": "Manufacture of cast iron pipes",
  "27.2C": "Manufacture of steel pipes",
  "27.3": "Manufacture of wiring and wiring devices",
  "27.31": "Manufacture of fibre optic cables",
  "27.31Z": "Manufacture of fibre optic cables",
  "27.32": "Manufacture of other electronic and electric wires and cables",
  "27.32Z": "Manufacture of other electronic and electric wires and cables",
  "27.33": "Manufacture of wiring devices",
  "27.33Z": "Manufacture of wiring devices",
  "27.3A": "Cold drawing",
  "27.3C": "Cold rolling of strips",
  "27.3E": "Cold forming or bending",
  "27.3G": "Cold drawing of wire",
  "27.4": "Manufacture of electric lighting equipment",
  "27.40": "Manufacture of electric lighting equipment",
  "27.40Z": "Manufacture of electric lighting equipment",
  "27.4A": "Production of precious metals",
  "27.4C": "Aluminium production",
  "27.4D": "Primary processing of aluminium",
  "27.4F": "Production of lead, zinc or tin",
  "27.4G": "Primary processing of lead, zinc or tin",
  "27.4J": "Copper production",
  "27.4K": "Primary processing of copper",
  "27.4M": "Metallurgy of other non-ferrous metals",
  "27.5": "Manufacture of domestic appliances",
  "27.51": "Manufacture of electric domestic appliances",
  "27.51Z": "Manufacture of electric domestic appliances",
  "27.52": "Manufacture of non-electric domestic appliances",
  "27.52Z": "Manufacture of non-electric domestic appliances",
  "27.5A": "Iron foundry",
  "27.5C": "Steel foundry",
  "27.5E": "Light metal foundry",
  "27.5G": "Foundry of other non-ferrous metals",
  "27.9": "Manufacture of other electrical equipment",
  "27.90": "Manufacture of other electrical equipment",
  "27.90Z": "Manufacture of other electrical equipment",
  "28": "Manufacture of machinery and equipment n.e.c.",
  "28.1": "Manufacture of general-purpose machinery",
  "28.11": "Manufacture of engines and turbines, except for aircraft, vehicle and cycle engines",
  "28.11Z": "Manufacture of engines and turbines, except for aircraft, vehicle and cycle engines",
  "28.12": "Manufacture of fluid power equipment",
  "28.12Z": "Manufacture of fluid power equipment",
  "28.13": "Manufacture of other pumps and compressors",
  "28.13Z": "Manufacture of other pumps and compressors",
  "28.14": "Manufacture of other taps and valves",
  "28.14Z": "Manufacture of other taps and valves",
  "28.15": "Manufacture of bearings, gears, gearing and driving elements",
  "28.15Z": "Manufacture of bearings, gears, gearing and driving elements",
  "28.1A": "Manufacture of metal structures",
  "28.1C": "Manufacture of metal joinery and closures",
  "28.2": "Manufacture of tanks, reservoirs and containers of metal; manufacture of central heating radiators and boilers",
  "28.21": "Manufacture of ovens, furnaces and furnace burners",
  "28.21Z": "Manufacture of ovens, furnaces and furnace burners",
  "28.22": "Manufacture of lifting and handling equipment",
  "28.22Z": "Manufacture of lifting and handling equipment",
  "28.23": "Manufacture of office machinery and equipment (except computers and peripheral equipment)",
  "28.23Z": "Manufacture of office machinery and equipment (except computers and peripheral equipment)",
  "28.24": "Manufacture of power-driven hand tools",
  "28.24Z": "Manufacture of power-driven hand tools",
  "28.25": "Manufacture of non-domestic cooling and ventilation equipment",
  "28.25Z": "Manufacture of non-domestic cooling and ventilation equipment",
  "28.29": "Manufacture of other general-purpose machinery n.e.c.",
  "28.29A": "Manufacture of packaging, conditioning and weighing equipment",
  "28.29B": "Manufacture of other general-purpose machinery",
  "28.2C": "Manufacture of metal tanks, cisterns and containers",
  "28.2D": "Manufacture of radiators and boilers for central heating",
  "28.3": "Manufacture of agricultural and forestry machinery",
  "28.30": "Manufacture of agricultural and forestry machinery",
  "28.30Z": "Manufacture of agricultural and forestry machinery",
  "28.3A": "Manufacture of steam generators",
  "28.3B": "Nuclear boilermaking",
  "28.3C": "Boilermaking-piping",
  "28.4": "Manufacture of metal forming machinery and machine tools",
  "28.41": "Manufacture of metal forming machinery",
  "28.41Z": "Manufacture of metal forming machinery and machine tools",
  "28.49": "Manufacture of other machine tools",
  "28.49Z": "Manufacture of other machine tools",
  "28.4A": "Forging, stamping, die forging",
  "28.4B": "Cutting, stamping",
  "28.4C": "Powder metallurgy",
  "28.5": "Treatment of metals; general mechanics",
  "28.5A": "Treatment and coating of metals",
  "28.5C": "Automatic turned parts manufacturing",
  "28.5D": "General mechanics",
  "28.6": "Manufacture of cutlery, tools and general hardware",
  "28.6A": "Manufacture of cutlery",
  "28.6C": "Manufacture of hand tools",
  "28.6D": "Manufacture of mechanical tools",
  "28.6F": "Manufacture of locks and fittings",
  "28.7": "Manufacture of other fabricated metal products",
  "28.7A": "Manufacture of metal drums and similar packaging",
  "28.7C": "Manufacture of light metal packaging",
  "28.7E": "Manufacture of wire products",
  "28.7G": "Manufacture of screws and bolts",
  "28.7H": "Manufacture of springs",
  "28.7J": "Manufacture of chains",
  "28.7L": "Manufacture of household metal articles",
  "28.7N": "Manufacture of small metal articles",
  "28.7Q": "Manufacture of various metal articles",
  "28.9": "Manufacture of other special-purpose machinery",
  "28.91": "Manufacture of machinery for metallurgy",
  "28.91Z": "Manufacture of machinery for metallurgy",
  "28.92": "Manufacture of machinery for mining, quarrying and construction",
  "28.92Z": "Manufacture of machinery for mining, quarrying and construction",
  "28.93": "Manufacture of machinery for food, beverage and tobacco processing",
  "28.93Z": "Manufacture of machinery for food, beverage and tobacco processing",
  "28.94": "Manufacture of machinery for textile, apparel and leather production",
  "28.94Z": "Manufacture of machinery for textile, apparel and leather production",
  "28.95": "Manufacture of machinery for paper and paperboard production",
  "28.95Z": "Manufacture of machinery for paper and paperboard production",
  "28.96": "Manufacture of plastics and rubber machinery",
  "28.96Z": "Manufacture of plastics and rubber machinery",
  "28.99": "Manufacture of other special-purpose machinery n.e.c.",
  "28.99A": "Manufacture of printing machinery",
  "28.99B": "Manufacture of other specialised machinery",
  "29": "Manufacture of motor vehicles, trailers and semi-trailers",
  "29.1": "Manufacture of motor vehicles",
  "29.10": "Manufacture of motor vehicles",
  "29.10Z": "Manufacture of motor vehicles",
  "29.1A": "Manufacture of engines and turbines",
  "29.1B": "Manufacture of pumps",
  "29.1D": "Manufacture of hydraulic and pneumatic transmissions",
  "29.1E": "Manufacture of compressors",
  "29.1F": "Manufacture of taps and valves",
  "29.1H": "Manufacture of bearings",
  "29.1J": "Manufacture of mechanical transmission elements",
  "29.2": "Manufacture of bodies for motor vehicles; manufacture of trailers and semi-trailers",
  "29.20": "Manufacture of bodies for motor vehicles; manufacture of trailers and semi-trailers",
  "29.20Z": "Manufacture of bodies for motor vehicles; manufacture of trailers and semi-trailers",
  "29.2A": "Manufacture of ovens and burners",
  "29.2C": "Manufacture of lifts, hoists and escalators",
  "29.2D": "Manufacture of lifting and handling equipment",
  "29.2F": "Manufacture of air-handling and industrial refrigerating equipment",
  "29.2H": "Manufacture of packaging and conditioning equipment",
  "29.2J": "Manufacture of weighing machinery",
  "29.2L": "Manufacture of machinery for chemical industries",
  "29.2M": "Manufacture of other general purpose machinery",
  "29.3": "Manufacture of parts and accessories for motor vehicles",
  "29.31": "Manufacture of electrical and electronic equipment for motor vehicles",
  "29.31Z": "Manufacture of electrical and electronic equipment for motor vehicles",
  "29.32": "Manufacture of other parts and accessories for motor vehicles",
  "29.32Z": "Manufacture of other parts and accessories for motor vehicles",
  "29.3A": "Manufacture of agricultural tractors",
  "29.3C": "Repair of agricultural machinery",
  "29.3D": "Manufacture of agricultural machinery",
  "29.4": "Manufacture of machine tools",
  "29.4A": "Manufacture of metal-working machine tools",
  "29.4B": "Manufacture of woodworking machine tools",
  "29.4C": "Manufacture of portable power-driven hand tools",
  "29.4D": "Manufacture of welding equipment",
  "29.4E": "Manufacture of other machine tools",
  "29.5": "Manufacture of other special purpose machinery",
  "29.5A": "Manufacture of machinery for metallurgy",
  "29.5B": "Manufacture of mining machinery for extraction",
  "29.5D": "Manufacture of public works machinery",
  "29.5E": "Manufacture of machinery for food and beverage processing",
  "29.5G": "Manufacture of machinery for textile industries",
  "29.5J": "Manufacture of machinery for paper and cardboard industries",
  "29.5L": "Manufacture of printing machinery",
  "29.5M": "Manufacture of machinery for working rubber or plastics",
  "29.5N": "Manufacture of molds and patterns",
  "29.5Q": "Manufacture of automatic assembly machines",
  "29.5R": "Manufacture of various specialized machinery",
  "29.6": "Manufacture of weapons and ammunition",
  "29.6A": "Manufacture of weaponry",
  "29.6B": "Manufacture of hunting, shooting and self-defense weapons",
  "29.7": "Manufacture of domestic appliances",
  "29.7A": "Manufacture of electrical domestic appliances",
  "29.7C": "Manufacture of non-electrical domestic appliances",
  "30": "Manufacture of other transport equipment",
  "30.0": "Manufacture of office machinery and computers",
  "30.0A": "Manufacture of office machinery",
  "30.0C": "Manufacture of computers and other IT equipment",
  "30.1": "Building of ships and boats",
  "30.11": "Building of ships and floating structures",
  "30.11Z": "Building of ships and floating structures",
  "30.12": "Building of pleasure and sporting boats",
  "30.12Z": "Building of pleasure and sporting boats",
  "30.2": "Manufacture of railway locomotives and rolling stock",
  "30.20": "Manufacture of railway locomotives and rolling stock",
  "30.20Z": "Manufacture of railway locomotives and rolling stock",
  "30.3": "Manufacture of air and spacecraft and related machinery",
  "30.30": "Manufacture of air and spacecraft and related machinery",
  "30.30Z": "Manufacture of air and spacecraft and related machinery",
  "30.4": "Manufacture of military fighting vehicles",
  "30.40": "Manufacture of military fighting vehicles",
  "30.40Z": "Manufacture of military fighting vehicles",
  "30.9": "Manufacture of transport equipment n.e.c.",
  "30.91": "Manufacture of motorcycles",
  "30.91Z": "Manufacture of motorcycles",
  "30.92": "Manufacture of bicycles and invalid carriages",
  "30.92Z": "Manufacture of bicycles and invalid carriages",
  "30.99": "Manufacture of other transport equipment n.e.c.",
  "30.99Z": "Manufacture of other transport equipment n.e.c.",
  "31": "Manufacture of furniture",
  "31.0": "Manufacture of furniture",
  "31.01": "Manufacture of office and shop furniture",
  "31.01Z": "Manufacture of office and shop furniture",
  "31.02": "Manufacture of kitchen furniture",
  "31.02Z": "Manufacture of kitchen furniture",
  "31.03": "Manufacture of mattresses",
  "31.03Z": "Manufacture of mattresses",
  "31.09": "Manufacture of other furniture",
  "31.09A": "Manufacture of indoor seating furniture",
  "31.09B": "Manufacture of other furniture and related furnishing industries",
  "31.1": "Manufacture of electric motors, generators and transformers",
  "31.1A": "Manufacture of small and medium power electric motors, generators and transformers",
  "31.1B": "Manufacture of large power electric motors, generators and transformers",
  "31.1C": "Repair of electrical equipment",
  "31.2": "Manufacture of electricity distribution and control apparatus",
  "31.2A": "Manufacture of low voltage electricity distribution and control apparatus",
  "31.2B": "Manufacture of high voltage electricity distribution and control apparatus",
  "31.3": "Manufacture of insulated wire and cable",
  "31.3Z": "Manufacture of insulated wire and cable",
  "31.4": "Manufacture of accumulators and primary cells and primary batteries",
  "31.4Z": "Manufacture of accumulators and primary cells and primary batteries",
  "31.5": "Manufacture of electric lighting equipment",
  "31.5A": "Manufacture of lamps",
  "31.5B": "Manufacture of autonomous electrical safety devices",
  "31.5C": "Manufacture of lighting equipment",
  "31.6": "Manufacture of other electrical equipment",
  "31.6A": "Manufacture of electrical equipment for engines and vehicles",
  "31.6C": "Manufacture of industrial electromagnetic equipment",
  "31.6D": "Manufacture of electrical equipment n.e.c.",
  "32": "Other manufacturing",
  "32.1": "Manufacture of jewellery, bijouterie and related articles",
  "32.11": "Striking of coins",
  "32.11Z": "Striking of coins",
  "32.12": "Manufacture of jewellery and related articles",
  "32.12Z": "Manufacture of jewellery and related articles",
  "32.13": "Manufacture of imitation jewellery and related articles",
  "32.13Z": "Manufacture of imitation jewellery and related articles",
  "32.1A": "Manufacture of passive components and capacitors",
  "32.1C": "Manufacture of active electronic components",
  "32.1D": "Assembly of electronic boards for third parties",
  "32.2": "Manufacture of musical instruments",
  "32.20": "Manufacture of musical instruments",
  "32.20Z": "Manufacture of musical instruments",
  "32.2A": "Manufacture of radio and television transmitting equipment",
  "32.2B": "Manufacture of telephony apparatus",
  "32.3": "Manufacture of sports goods",
  "32.30": "Manufacture of sports goods",
  "32.30Z": "Manufacture of sports goods",
  "32.3Z": "Manufacture of sound and video receiving, recording or reproducing apparatus",
  "32.4": "Manufacture of games and toys",
  "32.40": "Manufacture of games and toys",
  "32.40Z": "Manufacture of games and toys",
  "32.5": "Manufacture of medical and dental instruments and supplies",
  "32.50": "Manufacture of medical and dental instruments and supplies",
  "32.50A": "Manufacture of medical-surgical and dental equipment",
  "32.50B": "Manufacture of spectacles",
  "32.9": "Miscellaneous manufacturing n.e.c.",
  "32.91": "Manufacture of brooms and brushes",
  "32.91Z": "Manufacture of brooms and brushes",
  "32.99": "Other manufacturing n.e.c.",
  "32.99Z": "Other manufacturing n.e.c.",
  "33": "Repair and installation of machinery and equipment",
  "33.1": "Repair of fabricated metal products, machinery and equipment",
  "33.11": "Repair of fabricated metal products",
  "33.11Z": "Repair of fabricated metal products",
  "33.12": "Repair of machinery",
  "33.12Z": "Repair of machinery",
  "33.13": "Repair of electronic and optical equipment",
  "33.13Z": "Repair of electronic and optical equipment",
  "33.14": "Repair of electrical equipment",
  "33.14Z": "Repair of electrical equipment",
  "33.15": "Repair and maintenance of ships and boats",
  "33.15Z": "Repair and maintenance of ships and boats",
  "33.16": "Repair and maintenance of aircraft and spacecraft",
  "33.16Z": "Repair and maintenance of aircraft and spacecraft",
  "33.17": "Repair and maintenance of other transport equipment",
  "33.17Z": "Repair and maintenance of other transport equipment",
  "33.19": "Repair of other equipment",
  "33.19Z": "Repair of other equipment",
  "33.1A": "Manufacture of medical imaging and radiology equipment",
  "33.1B": "Manufacture of medical-surgical apparatus",
  "33.2": "Installation of industrial machinery and equipment",
  "33.20": "Installation of industrial machinery and equipment",
  "33.20A": "Installation of metal structures, boilermaking and piping",
  "33.20B": "Installation of mechanical machinery and equipment",
  "33.20C": "Overall design and on-site assembly of industrial process control equipment",
  "33.20D": "Installation of electrical equipment, electronic and optical equipment or other equipment",
  "33.2A": "Manufacture of navigation aids",
  "33.2B": "Manufacture of scientific and technical instrumentation",
  "33.3": "Manufacture of industrial process control equipment",
  "33.3Z": "Manufacture of industrial process control equipment",
  "33.4": "Manufacture of optical and photographic equipment",
  "33.4A": "Manufacture of spectacles",
  "33.4B": "Manufacture of optical instruments and photographic equipment",
  "33.5": "Watchmaking",
  "33.5Z": "Watchmaking",
  "34": "Manufacture of motor vehicles, trailers and semi-trailers",
  "34.1": "Manufacture of motor vehicles",
  "34.1Z": "Manufacture of motor vehicles",
  "34.2": "Manufacture of bodies for motor vehicles, trailers and semi-trailers",
  "34.2A": "Manufacture of automobile bodies",
  "34.2B": "Manufacture of caravans and leisure vehicles",
  "34.3": "Manufacture of parts and accessories for motor vehicles",
  "34.3Z": "Manufacture of parts and accessories for motor vehicles",
  "35": "Manufacture of other transport equipment",
  "35.1": "Building of ships and boats",
  "35.11": "Production of electricity",
  "35.11Z": "Production of electricity",
  "35.12": "Transmission of electricity",
  "35.12Z": "Transmission of electricity",
  "35.13": "Distribution of electricity",
  "35.13Z": "Distribution of electricity",
  "35.14": "Trade of electricity",
  "35.14Z": "Trade of electricity",
  "35.1A": "Building of warships",
  "35.1B": "Building of civilian ships",
  "35.1C": "Ship repair",
  "35.1E": "Building of pleasure boats",
  "35.2": "Manufacture of railway locomotives and rolling stock",
  "35.21": "Manufacture of gas; distribution of gaseous fuels through mains",
  "35.21Z": "Manufacture of gas; distribution of gaseous fuels through mains",
  "35.22": "Distribution of gaseous fuels through mains",
  "35.22Z": "Distribution of gaseous fuels through mains",
  "35.23": "Trade of gaseous fuels through mains",
  "35.23Z": "Trade of gaseous fuels through mains",
  "35.2Z": "Manufacture of railway locomotives and rolling stock",
  "35.3": "Manufacture of air and spacecraft and related machinery",
  "35.30": "Steam and air conditioning supply",
  "35.30Z": "Steam and air conditioning supply",
  "35.3A": "Manufacture of aircraft engines",
  "35.3B": "Manufacture of aircraft fuselages",
  "35.3C": "Manufacture of launchers and spacecraft",
  "35.4": "Manufacture of motorcycles and bicycles",
  "35.4A": "Manufacture of motorcycles",
  "35.4C": "Manufacture of bicycles",
  "35.4E": "Manufacture of invalid carriages",
  "35.5": "Manufacture of other transport equipment n.e.c.",
  "35.5Z": "Manufacture of other transport equipment n.e.c.",
  "36": "Water collection, treatment and supply",
  "36.0": "Water collection, treatment and supply",
  "36.00": "Water collection, treatment and supply",
  "36.00Z": "Water collection, treatment and supply",
  "36.1": "Manufacture of furniture",
  "36.1A": "Manufacture of seats",
  "36.1C": "Manufacture of office and shop furniture",
  "36.1E": "Manufacture of kitchen furniture",
  "36.1G": "Manufacture of household furniture",
  "36.1H": "Manufacture of garden and outdoor furniture",
  "36.1J": "Manufacture of furniture n.e.c.",
  "36.1K": "Related furnishing industries",
  "36.1M": "Manufacture of mattresses",
  "36.2": "Manufacture of jewellery, bijouterie and related articles",
  "36.2A": "Striking of coins",
  "36.2C": "Jewellery, goldsmithing, silversmithing",
  "36.3": "Manufacture of musical instruments",
  "36.3Z": "Manufacture of musical instruments",
  "36.4": "Manufacture of sports goods",
  "36.4Z": "Manufacture of sports goods",
  "36.5": "Manufacture of games and toys",
  "36.5Z": "Manufacture of games and toys",
  "36.6": "Other manufacturing n.e.c.",
  "36.6A": "Manufacture of imitation jewellery",
  "36.6C": "Manufacture of brushes and brooms",
  "36.6E": "Other manufacturing n.e.c.",
  "37": "Sewerage",
  "37.0": "Sewerage",
  "37.00": "Sewerage",
  "37.00Z": "Sewerage",
  "37.1": "Recovery of recyclable metal materials",
  "37.1Z": "Recovery of recyclable metal materials",
  "37.2": "Recovery of recyclable non-metallic materials",
  "37.2Z": "Recovery of recyclable non-metallic materials",
  "38": "Waste collection, treatment and disposal activities; materials recovery",
  "38.1": "Waste collection",
  "38.11": "Collection of non-hazardous waste",
  "38.11Z": "Collection of non-hazardous waste",
  "38.12": "Collection of hazardous waste",
  "38.12Z": "Collection of hazardous waste",
  "38.2": "Waste treatment and disposal",
  "38.21": "Treatment and disposal of non-hazardous waste",
  "38.21Z": "Treatment and disposal of non-hazardous waste",
  "38.22": "Treatment and disposal of hazardous waste",
  "38.22Z": "Treatment and disposal of hazardous waste",
  "38.3": "Materials recovery",
  "38.31": "Dismantling of wrecks",
  "38.31Z": "Dismantling of wrecks",
  "38.32": "Recovery of sorted materials",
  "38.32Z": "Recovery of sorted materials",
  "39": "Remediation activities and other waste management services",
  "39.0": "Remediation activities and other waste management services",
  "39.00": "Remediation activities and other waste management services",
  "39.00Z": "Remediation activities and other waste management services",
  "40": "Electricity, gas, steam and air conditioning supply",
  "40.1": "Production and distribution of electricity",
  "40.1A": "Production of electricity",
  "40.1C": "Transmission of electricity",
  "40.1E": "Distribution and trade of electricity",
  "40.2": "Manufacture of gas; distribution of gaseous fuels through mains",
  "40.2A": "Manufacture of manufactured gas",
  "40.2C": "Distribution of gaseous fuels through mains",
  "40.3": "Steam and air conditioning supply",
  "40.3Z": "Steam and air conditioning supply",
  "41": "Construction of buildings",
  "41.0": "Water collection, treatment and supply",
  "41.0Z": "Water collection, treatment and supply",
  "41.1": "Development of building projects",
  "41.10": "Development of building projects",
  "41.10A": "Development of residential building projects",
  "41.10B": "Development of office building projects",
  "41.10C": "Development of other building projects",
  "41.10D": "Legal vehicles for programs",
  "41.2": "Construction of residential and non-residential buildings",
  "41.20": "Construction of residential and non-residential buildings",
  "41.20A": "Construction of detached houses",
  "41.20B": "Construction of other buildings",
  "42": "Civil engineering",
  "42.1": "Construction of roads and railways",
  "42.11": "Construction of roads and motorways",
  "42.11Z": "Construction of roads and motorways",
  "42.12": "Construction of railways and underground railways",
  "42.12Z": "Construction of railways and underground railways",
  "42.13": "Construction of bridges and tunnels",
  "42.13A": "Construction of civil engineering structures",
  "42.13B": "Construction and maintenance of tunnels",
  "42.2": "Construction of utility projects",
  "42.21": "Construction of utility projects for fluids",
  "42.21Z": "Construction of utility projects for fluids",
  "42.22": "Construction of utility projects for electricity and telecommunications",
  "42.22Z": "Construction of utility projects for electricity and telecommunications",
  "42.9": "Construction of other civil engineering projects",
  "42.91": "Construction of water projects",
  "42.91Z": "Construction of water projects",
  "42.99": "Construction of other civil engineering projects n.e.c.",
  "42.99Z": "Construction of other civil engineering projects n.e.c.",
  "43": "Specialised construction activities",
  "43.1": "Demolition and site preparation",
  "43.11": "Demolition",
  "43.11Z": "Demolition",
  "43.12": "Site preparation",
  "43.12A": "Current earthmoving and preparatory works",
  "43.12B": "Specialised or large-scale earthmoving works",
  "43.13": "Test drilling and boring",
  "43.13Z": "Test drilling and boring",
  "43.2": "Electrical, plumbing and other construction installation activities",
  "43.21": "Electrical installation",
  "43.21A": "Electrical installation work in all premises",
  "43.21B": "Electrical installation work on public roads",
  "43.22": "Plumbing, heat and air-conditioning installation",
  "43.22A": "Water and gas installation work in all premises",
  "43.22B": "Installation of thermal and air-conditioning equipment",
  "43.29": "Other construction installation",
  "43.29A": "Insulation work",
  "43.29B": "Other installation work n.e.c.",
  "43.3": "Building completion and finishing",
  "43.31": "Plastering",
  "43.31Z": "Plastering",
  "43.32": "Joinery installation",
  "43.32A": "Wood and PVC joinery work",
  "43.32B": "Metal joinery and locksmithing work",
  "43.32C": "Fitting out of sales areas",
  "43.33": "Floor and wall covering",
  "43.33Z": "Floor and wall covering",
  "43.34": "Painting and glazing",
  "43.34Z": "Painting and glazing",
  "43.39": "Other building completion and finishing",
  "43.39Z": "Other building completion and finishing",
  "43.9": "Other specialised construction activities",
  "43.91": "Roofing activities",
  "43.91A": "Carpentry work",
  "43.91B": "Roofing by elements",
  "43.99": "Other specialised construction activities n.e.c.",
  "43.99A": "Waterproofing work",
  "43.99B": "Assembly of metal structures",
  "43.99C": "General masonry work and structural building work",
  "43.99D": "Other specialised construction work",
  "43.99E": "Rental of construction equipment with operator",
  "45": "Wholesale and retail trade and repair of motor vehicles and motorcycles",
  "45.1": "Sale of motor vehicles",
  "45.11": "Sale of cars and light motor vehicles",
  "45.11Z": "Sale of cars and light motor vehicles",
  "45.19": "Sale of other motor vehicles",
  "45.19Z": "Sale of other motor vehicles",
  "45.1A": "Various earthworks, demolition",
  "45.1B": "Large-scale earthworks",
  "45.1D": "Drilling and probing",
  "45.2": "Maintenance and repair of motor vehicles",
  "45.20": "Maintenance and repair of motor vehicles",
  "45.20A": "Maintenance and repair of light motor vehicles",
  "45.20B": "Maintenance and repair of other motor vehicles",
  "45.2A": "Construction of individual houses",
  "45.2B": "Construction of various buildings",
  "45.2C": "Construction of civil engineering structures",
  "45.2D": "Underground works",
  "45.2E": "Network construction",
  "45.2F": "Construction of power and telecommunication lines",
  "45.2J": "Roofing by elements",
  "45.2K": "Waterproofing works",
  "45.2L": "Carpentry work",
  "45.2N": "Construction of railways",
  "45.2P": "Construction of roads and sports fields",
  "45.2R": "Maritime and river works",
  "45.2T": "Lifting, assembly",
  "45.2U": "Other specialized construction work",
  "45.2V": "General masonry work",
  "45.3": "Sale of motor vehicle parts and accessories",
  "45.31": "Wholesale trade of motor vehicle parts and accessories",
  "45.31Z": "Wholesale trade of motor vehicle parts and accessories",
  "45.32": "Retail trade of motor vehicle parts and accessories",
  "45.32Z": "Retail trade of motor vehicle parts and accessories",
  "45.3A": "Electrical installation work",
  "45.3C": "Insulation work",
  "45.3E": "Water and gas installation",
  "45.3F": "Installation of heating and air conditioning equipment",
  "45.3H": "Other installation work",
  "45.4": "Sale, maintenance and repair of motorcycles and related parts and accessories",
  "45.40": "Sale, maintenance and repair of motorcycles and related parts and accessories",
  "45.40Z": "Sale, maintenance and repair of motorcycles and related parts and accessories",
  "45.4A": "Plastering",
  "45.4C": "Wood and plastic joinery",
  "45.4D": "Metal joinery; locksmithing",
  "45.4F": "Floor and wall covering",
  "45.4H": "Building mirrors; glazing",
  "45.4J": "Painting",
  "45.4L": "Fitting out of sales areas",
  "45.4M": "Finishing work n.e.c.",
  "45.5": "Rental of construction equipment with operator",
  "45.5Z": "Rental of construction equipment with operator",
  "46": "Wholesale trade, except of motor vehicles and motorcycles",
  "46.1": "Wholesale on a fee or contract basis",
  "46.11": "Agents in the sale of agricultural raw materials, live animals, textile raw materials and semi-finished goods",
  "46.11Z": "Agents in the sale of agricultural raw materials, live animals, textile raw materials and semi-finished goods",
  "46.12": "Agents in the sale of fuels, ores, metals and industrial chemicals",
  "46.12A": "Fuel purchasing centres",
  "46.12B": "Other agents in the sale of fuels, ores, metals and industrial chemicals",
  "46.13": "Agents in the sale of timber and building materials",
  "46.13Z": "Agents in the sale of timber and building materials",
  "46.14": "Agents in the sale of machinery, industrial equipment, ships and aircraft",
  "46.14Z": "Agents in the sale of machinery, industrial equipment, ships and aircraft",
  "46.15": "Agents in the sale of furniture, household goods and hardware",
  "46.15Z": "Agents in the sale of furniture, household goods and hardware",
  "46.16": "Agents in the sale of textiles, clothing, fur, footwear and leather goods",
  "46.16Z": "Agents in the sale of textiles, clothing, fur, footwear and leather goods",
  "46.17": "Agents in the sale of food, beverages and tobacco",
  "46.17A": "Food purchasing centres",
  "46.17B": "Other agents in the sale of food, beverages and tobacco",
  "46.18": "Agents specializing in the sale of other particular products",
  "46.18Z": "Agents specializing in the sale of other particular products",
  "46.19": "Agents in the sale of a variety of goods",
  "46.19A": "Non-food purchasing centres",
  "46.19B": "Other agents in the sale of a variety of goods",
  "46.2": "Wholesale of agricultural raw materials and live animals",
  "46.21": "Wholesale of grain, unmanufactured tobacco, seeds and animal feeds",
  "46.21Z": "Wholesale (business-to-business trade) of grain, unmanufactured tobacco, seeds and animal feeds",
  "46.22": "Wholesale of flowers and plants",
  "46.22Z": "Wholesale (business-to-business trade) of flowers and plants",
  "46.23": "Wholesale of live animals",
  "46.23Z": "Wholesale (business-to-business trade) of live animals",
  "46.24": "Wholesale of hides, skins and leather",
  "46.24Z": "Wholesale (business-to-business trade) of hides, skins and leather",
  "46.3": "Wholesale of food, beverages and tobacco",
  "46.31": "Wholesale of fruit and vegetables",
  "46.31Z": "Wholesale (business-to-business trade) of fruit and vegetables",
  "46.32": "Wholesale of meat and meat products",
  "46.32A": "Wholesale (business-to-business trade) of red meat",
  "46.32B": "Wholesale (business-to-business trade) of meat products",
  "46.32C": "Wholesale (business-to-business trade) of poultry and game",
  "46.33": "Wholesale of dairy products, eggs and edible oils and fats",
  "46.33Z": "Wholesale (business-to-business trade) of dairy products, eggs and edible oils and fats",
  "46.34": "Wholesale of beverages",
  "46.34Z": "Wholesale (business-to-business trade) of beverages",
  "46.35": "Wholesale of tobacco products",
  "46.35Z": "Wholesale (business-to-business trade) of tobacco products",
  "46.36": "Wholesale of sugar, chocolate and sugar confectionery",
  "46.36Z": "Wholesale (business-to-business trade) of sugar, chocolate and sugar confectionery",
  "46.37": "Wholesale of coffee, tea, cocoa and spices",
  "46.37Z": "Wholesale (business-to-business trade) of coffee, tea, cocoa and spices",
  "46.38": "Wholesale of other food, including fish, crustaceans and molluscs",
  "46.38A": "Wholesale (business-to-business trade) of fish, crustaceans and molluscs",
  "46.38B": "Other specialized food wholesale (business-to-business trade) n.e.c.",
  "46.39": "Non-specialised wholesale of food, beverages and tobacco",
  "46.39A": "Wholesale (business-to-business trade) of frozen food",
  "46.39B": "Non-specialised food wholesale (business-to-business trade)",
  "46.4": "Wholesale of household goods",
  "46.41": "Wholesale of textiles",
  "46.41Z": "Wholesale (business-to-business trade) of textiles",
  "46.42": "Wholesale of clothing and footwear",
  "46.42Z": "Wholesale (business-to-business trade) of clothing and footwear",
  "46.43": "Wholesale of electrical household appliances",
  "46.43Z": "Wholesale (business-to-business trade) of electrical household appliances",
  "46.44": "Wholesale of china and glassware and cleaning materials",
  "46.44Z": "Wholesale (business-to-business trade) of china and glassware and cleaning materials",
  "46.45": "Wholesale of perfume and cosmetics",
  "46.45Z": "Wholesale (business-to-business trade) of perfume and cosmetics",
  "46.46": "Wholesale of pharmaceutical goods",
  "46.46Z": "Wholesale (business-to-business trade) of pharmaceutical goods",
  "46.47": "Wholesale of furniture, carpets and lighting equipment",
  "46.47Z": "Wholesale (business-to-business trade) of furniture, carpets and lighting equipment",
  "46.48": "Wholesale of watches and jewellery",
  "46.48Z": "Wholesale (business-to-business trade) of watches and jewellery",
  "46.49": "Wholesale of other household goods",
  "46.49Z": "Wholesale (business-to-business trade) of other household goods",
  "46.5": "Wholesale of information and communication equipment",
  "46.51": "Wholesale of computers, computer peripheral equipment and software",
  "46.51Z": "Wholesale (business-to-business trade) of computers, computer peripheral equipment and software",
  "46.52": "Wholesale of electronic and telecommunications equipment and parts",
  "46.52Z": "Wholesale (business-to-business trade) of electronic and telecommunications equipment and parts",
  "46.6": "Wholesale of other machinery, equipment and supplies",
  "46.61": "Wholesale of agricultural machinery and equipment",
  "46.61Z": "Wholesale (business-to-business trade) of agricultural machinery and equipment",
  "46.62": "Wholesale of machine tools",
  "46.62Z": "Wholesale (business-to-business trade) of machine tools",
  "46.63": "Wholesale of mining, construction and civil engineering machinery",
  "46.63Z": "Wholesale (business-to-business trade) of mining, construction and civil engineering machinery",
  "46.64": "Wholesale of machinery for the textile industry and of sewing and knitting machines",
  "46.64Z": "Wholesale (business-to-business trade) of machinery for the textile industry and of sewing and knitting machines",
  "46.65": "Wholesale of office furniture",
  "46.65Z": "Wholesale (business-to-business trade) of office furniture",
  "46.66": "Wholesale of other office machinery and equipment",
  "46.66Z": "Wholesale (business-to-business trade) of other office machinery and equipment",
  "46.69": "Wholesale of other machinery and equipment",
  "46.69A": "Wholesale (business-to-business trade) of electrical equipment",
  "46.69B": "Wholesale (business-to-business trade) of various industrial supplies and equipment",
  "46.69C": "Wholesale (business-to-business trade) of various supplies and equipment for commerce and services",
  "46.7": "Other specialised wholesale",
  "46.71": "Wholesale of solid, liquid and gaseous fuels and related products",
  "46.71Z": "Wholesale (business-to-business trade) of solid, liquid and gaseous fuels and related products",
  "46.72": "Wholesale of metals and metal ores",
  "46.72Z": "Wholesale (business-to-business trade) of metals and metal ores",
  "46.73": "Wholesale of wood, construction materials and sanitary equipment",
  "46.73A": "Wholesale (business-to-business trade) of wood and construction materials",
  "46.73B": "Wholesale (business-to-business trade) of sanitary appliances and decorative products",
  "46.74": "Wholesale of hardware, plumbing and heating equipment and supplies",
  "46.74A": "Wholesale (business-to-business trade) of hardware",
  "46.74B": "Wholesale (business-to-business trade) of plumbing and heating supplies",
  "46.75": "Wholesale of chemical products",
  "46.75Z": "Wholesale (business-to-business trade) of chemical products",
  "46.76": "Wholesale of other intermediate products",
  "46.76Z": "Wholesale (business-to-business trade) of other intermediate products",
  "46.77": "Wholesale of waste and scrap",
  "46.77Z": "Wholesale (business-to-business trade) of waste and scrap",
  "46.9": "Non-specialised wholesale trade",
  "46.90": "Non-specialised wholesale trade",
  "46.90Z": "Non-specialised wholesale (business-to-business trade)",
  "47": "Retail trade, except of motor vehicles and motorcycles",
  "47.1": "Retail trade in non-specialised stores",
  "47.11": "Retail trade in non-specialised stores with food, beverages or tobacco predominating",
  "47.11A": "Retail trade of frozen products",
  "47.11B": "General food retail",
  "47.11C": "Mini-markets",
  "47.11D": "Supermarkets",
  "47.11E": "Variety stores",
  "47.11F": "Hypermarkets",
  "47.19": "Other retail trade in non-specialised stores",
  "47.19A": "Department stores",
  "47.19B": "Other retail trade in non-specialised stores",
  "47.2": "Retail trade of food, beverages and tobacco in specialised stores",
  "47.21": "Retail trade of fruit and vegetables in specialised stores",
  "47.21Z": "Retail trade of fruit and vegetables in specialised stores",
  "47.22": "Retail trade of meat and meat products in specialised stores",
  "47.22Z": "Retail trade of meat and meat products in specialised stores",
  "47.23": "Retail trade of fish, crustaceans and molluscs in specialised stores",
  "47.23Z": "Retail trade of fish, crustaceans and molluscs in specialised stores",
  "47.24": "Retail trade of bread, cakes, pastry and confectionery in specialised stores",
  "47.24Z": "Retail trade of bread, cakes, pastry and confectionery in specialised stores",
  "47.25": "Retail trade of beverages in specialised stores",
  "47.25Z": "Retail trade of beverages in specialised stores",
  "47.26": "Retail trade of tobacco products in specialised stores",
  "47.26Z": "Retail trade of tobacco products in specialised stores",
  "47.29": "Other retail trade of food, beverages and tobacco in specialised stores",
  "47.29Z": "Other retail trade of food, beverages and tobacco in specialised stores",
  "47.3": "Retail trade of automotive fuel in specialised stores",
  "47.30": "Retail trade of automotive fuel in specialised stores",
  "47.30Z": "Retail trade of automotive fuel in specialised stores",
  "47.4": "Retail trade of information and communication equipment in specialised stores",
  "47.41": "Retail trade of computers, peripheral units and software in specialised stores",
  "47.41Z": "Retail trade of computers, peripheral units and software in specialised stores",
  "47.42": "Retail trade of telecommunications equipment in specialised stores",
  "47.42Z": "Retail trade of telecommunications equipment in specialised stores",
  "47.43": "Retail trade of audio and video equipment in specialised stores",
  "47.43Z": "Retail trade of audio and video equipment in specialised stores",
  "47.5": "Retail trade of other household equipment in specialised stores",
  "47.51": "Retail trade of textiles in specialised stores",
  "47.51Z": "Retail trade of textiles in specialised stores",
  "47.52": "Retail trade of hardware, paints and glass in specialised stores",
  "47.52A": "Retail trade of hardware, paints and glass in small areas (less than 400 m2)",
  "47.52B": "Retail trade of hardware, paints and glass in large areas (400 m2 and more)",
  "47.53": "Retail trade of carpets, rugs and wall and floor coverings in specialised stores",
  "47.53Z": "Retail trade of carpets, rugs and wall and floor coverings in specialised stores",
  "47.54": "Retail trade of electrical household appliances in specialised stores",
  "47.54Z": "Retail trade of electrical household appliances in specialised stores",
  "47.59": "Retail trade of furniture, lighting equipment and other household articles in specialised stores",
  "47.59A": "Retail trade of furniture",
  "47.59B": "Retail trade of other household equipment",
  "47.6": "Retail trade of cultural and recreation goods in specialised stores",
  "47.61": "Retail trade of books in specialised stores",
  "47.61Z": "Retail trade of books in specialised stores",
  "47.62": "Retail trade of newspapers and stationery in specialised stores",
  "47.62Z": "Retail trade of newspapers and stationery in specialised stores",
  "47.63": "Retail trade of music and video recordings in specialised stores",
  "47.63Z": "Retail trade of music and video recordings in specialised stores",
  "47.64": "Retail trade of sports goods in specialised stores",
  "47.64Z": "Retail trade of sports goods in specialised stores",
  "47.65": "Retail trade of games and toys in specialised stores",
  "47.65Z": "Retail trade of games and toys in specialised stores",
  "47.7": "Other retail trade in specialised stores",
  "47.71": "Retail trade of clothing in specialised stores",
  "47.71Z": "Retail trade of clothing in specialised stores",
  "47.72": "Retail trade of footwear and leather goods in specialised stores",
  "47.72A": "Retail trade of footwear",
  "47.72B": "Retail trade of leather goods and travel accessories",
  "47.73": "Retail trade of pharmaceutical goods in specialised stores",
  "47.73Z": "Retail trade of pharmaceutical goods in specialised stores",
  "47.74": "Retail trade of medical and orthopaedic goods in specialised stores",
  "47.74Z": "Retail trade of medical and orthopaedic goods in specialised stores",
  "47.75": "Retail trade of cosmetic and toilet articles in specialised stores",
  "47.75Z": "Retail trade of cosmetic and toilet articles in specialised stores",
  "47.76": "Retail trade of flowers, plants, seeds, fertilisers, pet animals and pet food in specialised stores",
  "47.76Z": "Retail trade of flowers, plants, seeds, fertilisers, pet animals and pet food in specialised stores",
  "47.77": "Retail trade of watches and jewellery in specialised stores",
  "47.77Z": "Retail trade of watches and jewellery in specialised stores",
  "47.78": "Other retail trade of new goods in specialised stores",
  "47.78A": "Optical retail",
  "47.78B": "Retail trade of coal and fuels",
  "47.78C": "Other various specialized retail trades",
  "47.79": "Retail trade of second-hand goods in stores",
  "47.79Z": "Retail trade of second-hand goods in stores",
  "47.8": "Retail trade via stalls and markets",
  "47.81": "Retail trade of food via stalls and markets",
  "47.81Z": "Retail trade of food via stalls and markets",
  "47.82": "Retail trade of textiles, clothing and footwear via stalls and markets",
  "47.82Z": "Retail trade of textiles, clothing and footwear via stalls and markets",
  "47.89": "Other retail trade via stalls and markets",
  "47.89Z": "Other retail trade via stalls and markets",
  "47.9": "Retail trade not in stores, stalls or markets",
  "47.91": "Retail trade via mail order houses or via Internet",
  "47.91A": "General mail order sales",
  "47.91B": "Specialised mail order sales",
  "47.99": "Other retail trade not in stores, stalls or markets",
  "47.99A": "Door-to-door sales",
  "47.99B": "Sales via vending machines and other retail trade not in stores, stalls or markets n.e.c.",
  "49": "Land transport and transport via pipelines",
  "49.1": "Passenger rail transport, interurban",
  "49.10": "Passenger rail transport, interurban",
  "49.10Z": "Passenger rail transport, interurban",
  "49.2": "Freight rail transport",
  "49.20": "Freight rail transport",
  "49.20Z": "Freight rail transport",
  "49.3": "Other passenger land transport",
  "49.31": "Urban and suburban passenger land transport",
  "49.31Z": "Urban and suburban passenger land transport",
  "49.32": "Taxi operation",
  "49.32Z": "Taxi operation",
  "49.39": "Other passenger land transport n.e.c.",
  "49.39A": "Regular road passenger transport",
  "49.39B": "Other road passenger transport",
  "49.39C": "Cable cars, ski lifts",
  "49.4": "Freight transport by road and removal services",
  "49.41": "Freight transport by road",
  "49.41A": "Interurban freight transport by road",
  "49.41B": "Local freight transport by road",
  "49.41C": "Rental of trucks with driver",
  "49.42": "Removal services",
  "49.42Z": "Removal services",
  "49.5": "Transport via pipelines",
  "49.50": "Transport via pipelines",
  "49.50Z": "Transport via pipelines",
  "5": "Fishing, aquaculture, related services",
  "50": "Water transport",
  "50.1": "Sea and coastal passenger water transport",
  "50.10": "Sea and coastal passenger water transport",
  "50.10Z": "Sea and coastal passenger water transport",
  "50.1Z": "Sale and repair of motor vehicles",
  "50.2": "Sea and coastal freight water transport",
  "50.20": "Sea and coastal freight water transport",
  "50.20Z": "Sea and coastal freight water transport",
  "50.2Z": "Maintenance and repair of motor vehicles",
  "50.3": "Inland passenger water transport",
  "50.30": "Inland passenger water transport",
  "50.30Z": "Inland passenger water transport",
  "50.3A": "Wholesale of automotive equipment",
  "50.3B": "Retail trade of automotive equipment",
  "50.4": "Inland freight water transport",
  "50.40": "Inland freight water transport",
  "50.40Z": "Inland freight water transport",
  "50.4Z": "Sale and repair of motorcycles",
  "50.5": "Retail sale of automotive fuel",
  "50.5Z": "Retail sale of automotive fuel",
  "51": "Air transport",
  "51.1": "Passenger air transport",
  "51.10": "Passenger air transport",
  "51.10Z": "Passenger air transport",
  "51.1A": "Agents in the sale of agricultural raw materials, live animals, textile raw materials and semi-finished goods",
  "51.1C": "Agents in the sale of fuels, metals, minerals and chemicals",
  "51.1E": "Agents in the sale of timber and building materials",
  "51.1G": "Agents in the sale of machinery, industrial equipment, ships and aircraft",
  "51.1J": "Agents in the sale of furniture, household goods and hardware",
  "51.1L": "Agents in the sale of textiles, clothing, footwear and leather goods",
  "51.1N": "Agents in the sale of food products",
  "51.1P": "Food purchasing centres",
  "51.1R": "Other specialised agents in wholesale trade",
  "51.1T": "Non-specialised agents in wholesale trade",
  "51.1U": "Non-food purchasing centres",
  "51.2": "Freight air transport",
  "51.21": "Freight air transport",
  "51.21Z": "Freight air transport",
  "51.22": "Space transport",
  "51.22Z": "Space transport",
  "51.2A": "Wholesale of cereals and animal feed",
  "51.2C": "Wholesale of flowers and plants",
  "51.2E": "Wholesale of live animals",
  "51.2G": "Wholesale of hides and skins",
  "51.2J": "Wholesale of unmanufactured tobacco",
  "51.3": "Wholesale of food, beverages and tobacco",
  "51.3A": "Wholesale of fruit and vegetables",
  "51.3C": "Wholesale of butchery meat",
  "51.3D": "Wholesale of meat products",
  "51.3E": "Wholesale of poultry and game",
  "51.3G": "Wholesale of dairy products, eggs, oils",
  "51.3J": "Wholesale of beverages",
  "51.3L": "Wholesale of tobacco",
  "51.3N": "Wholesale of sugar, chocolate and confectionery",
  "51.3Q": "Wholesale of coffee, tea, cocoa and spices",
  "51.3S": "Wholesale of fish, crustaceans and molluscs",
  "51.3T": "Various specialized food wholesale trades",
  "51.3V": "Wholesale of frozen products",
  "51.3W": "Non-specialised food wholesale",
  "51.4": "Wholesale of non-food consumer goods",
  "51.4A": "Wholesale of textiles",
  "51.4C": "Wholesale of clothing",
  "51.4D": "Wholesale of footwear",
  "51.4F": "Wholesale of household electrical appliances and radios and televisions",
  "51.4H": "Wholesale of household crockery and glassware",
  "51.4J": "Wholesale of products for home maintenance and furnishing",
  "51.4L": "Wholesale of perfumery and beauty products",
  "51.4N": "Wholesale of pharmaceutical products",
  "51.4Q": "Wholesale of stationery",
  "51.4R": "Wholesale of toys",
  "51.4S": "Other wholesale of consumer goods",
  "51.5": "Wholesale of non-agricultural intermediate products",
  "51.5A": "Wholesale of fuels",
  "51.5C": "Wholesale of ores and metals",
  "51.5E": "Wholesale of wood and derived products",
  "51.5F": "Wholesale of construction materials and sanitary appliances",
  "51.5H": "Wholesale of hardware",
  "51.5J": "Wholesale of plumbing and heating supplies",
  "51.5L": "Wholesale of chemical products",
  "51.5N": "Wholesale of other intermediate products",
  "51.5Q": "Wholesale of waste and scrap",
  "51.8": "Wholesale of industrial equipment",
  "51.8A": "Wholesale of machine tools",
  "51.8C": "Wholesale of machinery for mining, construction and civil engineering",
  "51.8E": "Wholesale of machinery for textile industry and clothing",
  "51.8G": "Wholesale of computers, peripheral IT equipment and software packages",
  "51.8H": "Wholesale of other office machinery and equipment",
  "51.8J": "Wholesale of electronic components and other equipment",
  "51.8L": "Wholesale of electrical equipment",
  "51.8M": "Wholesale of various industrial supplies and equipment",
  "51.8N": "Wholesale of various supplies and equipment for commerce and services",
  "51.8P": "Wholesale of agricultural machinery",
  "51.9": "Other wholesale trade",
  "51.9A": "Other specialized wholesale trade",
  "51.9B": "Non-specialized wholesale trade",
  "52": "Warehousing and support activities for transportation",
  "52.1": "Warehousing and storage",
  "52.10": "Warehousing and storage",
  "52.10A": "Refrigerated warehousing and storage",
  "52.10B": "Non-refrigerated warehousing and storage",
  "52.1A": "Retail trade of frozen products",
  "52.1B": "General food retail",
  "52.1C": "Mini-markets",
  "52.1D": "Supermarkets",
  "52.1E": "Variety stores",
  "52.1F": "Hypermarkets",
  "52.1H": "Department stores",
  "52.1J": "Other retail trade in non-specialised stores",
  "52.2": "Support activities for transportation",
  "52.21": "Service activities incidental to land transportation",
  "52.21Z": "Service activities incidental to land transportation",
  "52.22": "Service activities incidental to water transportation",
  "52.22Z": "Service activities incidental to water transportation",
  "52.23": "Service activities incidental to air transportation",
  "52.23Z": "Service activities incidental to air transportation",
  "52.24": "Cargo handling",
  "52.24A": "Port cargo handling",
  "52.24B": "Non-port cargo handling",
  "52.29": "Other support activities for transportation",
  "52.29A": "Courier, express freight",
  "52.29B": "Freight forwarding and transport organisation",
  "52.2A": "Retail trade of fruits and vegetables",
  "52.2C": "Retail trade of meat and meat products",
  "52.2E": "Retail trade of fish, crustaceans and molluscs",
  "52.2G": "Retail trade of bread, pastry and confectionery",
  "52.2J": "Retail trade of beverages",
  "52.2L": "Retail trade of tobacco",
  "52.2N": "Retail trade of dairy products",
  "52.2P": "Various specialized food retail trades",
  "52.3": "Retail trade of pharmaceutical and perfumery products",
  "52.3A": "Retail trade of pharmaceutical products",
  "52.3C": "Retail trade of medical and orthopedic articles",
  "52.3E": "Retail trade of perfumery and beauty products",
  "52.4": "Other retail trade in specialised stores",
  "52.4A": "Retail trade of textiles",
  "52.4C": "Retail trade of clothing",
  "52.4E": "Retail trade of footwear",
  "52.4F": "Retail trade of leather goods and travel articles",
  "52.4H": "Retail trade of furniture",
  "52.4J": "Retail trade of household equipment",
  "52.4L": "Retail trade of household electrical appliances, radios and televisions",
  "52.4N": "Retail trade of hardware",
  "52.4P": "DIY retail",
  "52.4R": "Retail trade of books, newspapers and stationery",
  "52.4T": "Optical and photographic retail",
  "52.4U": "Retail trade of floor and wall coverings",
  "52.4V": "Retail trade of watches and jewellery",
  "52.4W": "Retail trade of sports and leisure articles",
  "52.4X": "Retail trade of flowers",
  "52.4Y": "Retail trade of coal and fuels",
  "52.4Z": "Various specialized retail trades in stores",
  "52.5": "Retail trade of second-hand goods",
  "52.5Z": "Retail trade of second-hand goods",
  "52.6": "Retail trade not in stores",
  "52.6A": "General mail order sales",
  "52.6B": "Specialised mail order sales",
  "52.6D": "Food retail trade via stalls and markets",
  "52.6E": "Non-food retail trade via stalls and markets",
  "52.6G": "Door-to-door sales",
  "52.6H": "Sales via vending machines",
  "52.7": "Repair of personal and household goods",
  "52.7A": "Repair of footwear and leather articles",
  "52.7C": "Repair of consumer electronic equipment",
  "52.7D": "Repair of household electrical appliances",
  "52.7F": "Repair of watches, clocks and jewellery",
  "52.7H": "Repair of personal and household goods n.e.c.",
  "53": "Postal and courier activities",
  "53.1": "Postal activities under universal service obligation",
  "53.10": "Postal activities under universal service obligation",
  "53.10Z": "Postal activities under universal service obligation",
  "53.2": "Other postal and courier activities",
  "53.20": "Other postal and courier activities",
  "53.20Z": "Other postal and courier activities",
  "55": "Accommodation",
  "55.1": "Hotels and similar accommodation",
  "55.10": "Hotels and similar accommodation",
  "55.10Z": "Hotels and similar accommodation",
  "55.1A": "Tourist hotels with restaurant",
  "55.1C": "Tourist hotels without restaurant",
  "55.1E": "Other hotels",
  "55.2": "Holiday and other short-stay accommodation",
  "55.20": "Holiday and other short-stay accommodation",
  "55.20Z": "Holiday and other short-stay accommodation",
  "55.2A": "Youth hostels and mountain shelters",
  "55.2C": "Camping grounds operation",
  "55.2E": "Other tourist accommodation",
  "55.2F": "Non-tourist collective accommodation",
  "55.3": "Camping grounds, recreational vehicle parks and trailer parks",
  "55.30": "Camping grounds, recreational vehicle parks and trailer parks",
  "55.30Z": "Camping grounds, recreational vehicle parks and trailer parks",
  "55.3A": "Traditional restaurants",
  "55.3B": "Fast food restaurants",
  "55.4": "Beverage serving activities",
  "55.4A": "Cafés, tobacco shops",
  "55.4B": "Drinking establishments",
  "55.4C": "Discotheques",
  "55.5": "Canteens and catering",
  "55.5A": "Canteens and company restaurants",
  "55.5C": "Contract catering",
  "55.5D": "Caterers, reception organisation",
  "55.9": "Other accommodation",
  "55.90": "Other accommodation",
  "55.90Z": "Other accommodation",
  "56": "Food and beverage service activities",
  "56.1": "Restaurants and mobile food service activities",
  "56.10": "Restaurants and mobile food service activities",
  "56.10A": "Traditional restaurants",
  "56.10B": "Cafeterias and other self-service restaurants",
  "56.10C": "Fast food restaurants",
  "56.2": "Event catering and other food service activities",
  "56.21": "Event catering activities",
  "56.21Z": "Event catering activities",
  "56.29": "Other food service activities",
  "56.29A": "Contract catering",
  "56.29B": "Other food service activities n.e.c.",
  "56.3": "Beverage serving activities",
  "56.30": "Beverage serving activities",
  "56.30Z": "Beverage serving activities",
  "58": "Publishing activities",
  "58.1": "Publishing of books, periodicals and other publishing activities",
  "58.11": "Book publishing",
  "58.11Z": "Book publishing",
  "58.12": "Publishing of directories and mailing lists",
  "58.12Z": "Publishing of directories and mailing lists",
  "58.13": "Publishing of newspapers",
  "58.13Z": "Publishing of newspapers",
  "58.14": "Publishing of journals and periodicals",
  "58.14Z": "Publishing of journals and periodicals",
  "58.19": "Other publishing activities",
  "58.19Z": "Other publishing activities",
  "58.2": "Software publishing",
  "58.21": "Publishing of computer games",
  "58.21Z": "Publishing of computer games",
  "58.29": "Other software publishing",
  "58.29A": "Publishing of system and network software",
  "58.29B": "Publishing of development tools and languages",
  "58.29C": "Publishing of application software",
  "59": "Motion picture, video and television programme production, sound recording and music publishing activities",
  "59.1": "Motion picture, video and television programme activities",
  "59.11": "Motion picture, video and television programme production activities",
  "59.11A": "Production of films and television programmes",
  "59.11B": "Production of institutional and advertising films",
  "59.11C": "Production of films for cinema",
  "59.12": "Motion picture, video and television programme post-production activities",
  "59.12Z": "Motion picture, video and television programme post-production activities",
  "59.13": "Motion picture, video and television programme distribution activities",
  "59.13A": "Distribution of cinematographic films",
  "59.13B": "Video editing and distribution",
  "59.14": "Motion picture projection activities",
  "59.14Z": "Motion picture projection activities",
  "59.2": "Sound recording and music publishing activities",
  "59.20": "Sound recording and music publishing activities",
  "59.20Z": "Sound recording and music publishing activities",
  "60": "Programming and broadcasting activities",
  "60.1": "Radio broadcasting",
  "60.10": "Radio broadcasting",
  "60.10Z": "Radio broadcasting",
  "60.1Z": "Rail transport",
  "60.2": "Television programming and broadcasting activities",
  "60.20": "Television programming and broadcasting activities",
  "60.20A": "General interest channel publishing",
  "60.20B": "Thematic channel publishing",
  "60.2A": "Urban passenger transport",
  "60.2B": "Regular road passenger transport",
  "60.2C": "Cable cars, ski lifts",
  "60.2E": "Taxi transport of passengers",
  "60.2G": "Other road passenger transport",
  "60.2L": "Local road freight transport",
  "60.2M": "Interurban road freight transport",
  "60.2N": "Removal services",
  "60.2P": "Rental of trucks with driver",
  "60.3": "Transport via pipelines",
  "60.3Z": "Transport via pipelines",
  "61": "Telecommunications",
  "61.1": "Wired telecommunications activities",
  "61.10": "Wired telecommunications activities",
  "61.10Z": "Wired telecommunications activities",
  "61.1A": "Maritime transport",
  "61.1B": "Coastal transport",
  "61.2": "Wireless telecommunications activities",
  "61.20": "Wireless telecommunications activities",
  "61.20Z": "Wireless telecommunications activities",
  "61.2Z": "Inland water transport",
  "61.3": "Satellite telecommunications activities",
  "61.30": "Satellite telecommunications activities",
  "61.30Z": "Satellite telecommunications activities",
  "61.9": "Other telecommunications activities",
  "61.90": "Other telecommunications activities",
  "61.90Z": "Other telecommunications activities",
  "62": "Computer programming, consultancy and related activities",
  "62.0": "Computer programming, consultancy and other IT activities",
  "62.01": "Computer programming activities",
  "62.01Z": "Computer programming activities",
  "62.02": "Computer consultancy activities",
  "62.02A": "Information technology (IT) systems and software consulting",
  "62.02B": "Third-party maintenance of IT systems and applications",
  "62.03": "Computer facilities management activities",
  "62.03Z": "Computer facilities management activities",
  "62.09": "Other information technology service activities",
  "62.09Z": "Other information technology service activities",
  "62.1": "Regular air transport",
  "62.1Z": "Regular air transport",
  "62.2": "Non-regular air transport",
  "62.2Z": "Non-regular air transport",
  "62.3": "Space transport",
  "62.3Z": "Space transport",
  "63": "Information service activities",
  "63.1": "Data processing, hosting and related activities; web portals",
  "63.11": "Data processing, hosting and related activities",
  "63.11Z": "Data processing, hosting and related activities",
  "63.12": "Web portals",
  "63.12Z": "Web portals",
  "63.1A": "Port handling",
  "63.1B": "Non-port handling",
  "63.1D": "Refrigerated storage",
  "63.1E": "Non-refrigerated storage",
  "63.2": "Management of transport infrastructures",
  "63.2A": "Management of land transport infrastructures",
  "63.2C": "Port, maritime and river services",
  "63.2E": "Airport services",
  "63.3": "Travel agency activities",
  "63.3Z": "Travel agency activities",
  "63.4": "Freight transport organisation",
  "63.4A": "Courier, express freight",
  "63.4B": "Chartering",
  "63.4C": "Organisation of international transport",
  "63.9": "Other information service activities",
  "63.91": "News agency activities",
  "63.91Z": "News agency activities",
  "63.99": "Other information service activities n.e.c.",
  "63.99Z": "Other information service activities n.e.c.",
  "64": "Financial service activities, except insurance and pension funding",
  "64.1": "Monetary intermediation",
  "64.11": "Central banking",
  "64.11Z": "Central banking",
  "64.19": "Other monetary intermediation",
  "64.19Z": "Other monetary intermediation",
  "64.1A": "National postal services",
  "64.1C": "Other courier activities",
  "64.2": "Activities of holding companies",
  "64.20": "Activities of holding companies",
  "64.20Z": "Activities of holding companies",
  "64.2C": "Telecommunications (excluding audiovisual transmission)",
  "64.2D": "Transmission of radio and television broadcasts",
  "64.3": "Trusts, funds and similar financial entities",
  "64.30": "Trusts, funds and similar financial entities",
  "64.30Z": "Trusts, funds and similar financial entities",
  "64.9": "Other financial service activities, except insurance and pension funding n.e.c.",
  "64.91": "Financial leasing",
  "64.91Z": "Financial leasing",
  "64.92": "Other credit granting",
  "64.92Z": "Other credit granting",
  "64.99": "Other financial service activities, except insurance and pension funding n.e.c.",
  "64.99Z": "Other financial service activities, except insurance and pension funding n.e.c.",
  "65": "Insurance, reinsurance and pension funding, except compulsory social security",
  "65.1": "Insurance",
  "65.11": "Life insurance",
  "65.11Z": "Life insurance",
  "65.12": "Non-life insurance",
  "65.12Z": "Non-life insurance",
  "65.1A": "Central bank",
  "65.1C": "Banks",
  "65.1D": "Mutual banks",
  "65.1E": "Savings banks",
  "65.1F": "Monetary intermediation n.e.c.",
  "65.2": "Reinsurance",
  "65.20": "Reinsurance",
  "65.20Z": "Reinsurance",
  "65.2A": "Financial leasing",
  "65.2C": "Credit granting",
  "65.2E": "Undertakings for collective investment in transferable securities",
  "65.2F": "Various financial intermediation activities",
  "65.3": "Pension funding",
  "65.30": "Pension funding",
  "65.30Z": "Pension funding",
  "66": "Activities auxiliary to financial services and insurance activities",
  "66.0": "Insurance",
  "66.0A": "Life insurance and capitalization",
  "66.0C": "Pension funds",
  "66.0E": "Non-life insurance",
  "66.0F": "Reinsurance",
  "66.0G": "Insurance under the mutual code",
  "66.1": "Activities auxiliary to financial services, except insurance and pension funding",
  "66.11": "Administration of financial markets",
  "66.11Z": "Administration of financial markets",
  "66.12": "Security and commodity contracts brokerage",
  "66.12Z": "Security and commodity contracts brokerage",
  "66.19": "Other activities auxiliary to financial services, except insurance and pension funding n.e.c.",
  "66.19A": "Legal support for movable asset management",
  "66.19B": "Other activities auxiliary to financial services, except insurance and pension funding n.e.c.",
  "66.2": "Activities auxiliary to insurance and pension funding",
  "66.21": "Risk and damage evaluation",
  "66.21Z": "Risk and damage evaluation",
  "66.22": "Activities of insurance agents and brokers",
  "66.22Z": "Activities of insurance agents and brokers",
  "66.29": "Other activities auxiliary to insurance and pension funding n.e.c.",
  "66.29Z": "Other activities auxiliary to insurance and pension funding n.e.c.",
  "66.3": "Fund management activities",
  "66.30": "Fund management activities",
  "66.30Z": "Fund management activities",
  "67": "Activities auxiliary to financial and insurance services",
  "67.1": "Financial auxiliaries",
  "67.1A": "Administration of financial markets",
  "67.1C": "Portfolio management",
  "67.1E": "Other financial auxiliaries",
  "67.2": "Insurance auxiliaries",
  "67.2Z": "Insurance auxiliaries",
  "68": "Real estate activities",
  "68.1": "Buying and selling of own real estate",
  "68.10": "Buying and selling of own real estate",
  "68.10Z": "Buying and selling of own real estate",
  "68.2": "Renting and operating of own or leased real estate",
  "68.20": "Renting and operating of own or leased real estate",
  "68.20A": "Rental of dwellings",
  "68.20B": "Rental of land and other real estate",
  "68.3": "Real estate activities on a fee or contract basis",
  "68.31": "Real estate agencies",
  "68.31Z": "Real estate agencies",
  "68.32": "Management of real estate on a fee or contract basis",
  "68.32A": "Management of buildings and other real estate",
  "68.32B": "Legal support for real estate asset management",
  "69": "Legal and accounting activities",
  "69.1": "Legal activities",
  "69.10": "Legal activities",
  "69.10Z": "Legal activities",
  "69.2": "Accounting, bookkeeping and auditing activities; tax consultancy",
  "69.20": "Accounting, bookkeeping and auditing activities; tax consultancy",
  "69.20Z": "Accounting, bookkeeping and auditing activities; tax consultancy",
  "70": "Activities of head offices; management consultancy activities",
  "70.1": "Activities of head offices",
  "70.10": "Activities of head offices",
  "70.10Z": "Activities of head offices",
  "70.1A": "Real estate development of residential buildings",
  "70.1B": "Real estate development of offices",
  "70.1C": "Real estate development of infrastructures",
  "70.1D": "Legal vehicles for programs",
  "70.1F": "Real estate agents",
  "70.2": "Management consultancy activities",
  "70.21": "Public relations and communication activities",
  "70.21Z": "Public relations and communication activities",
  "70.22": "Business and other management consultancy activities",
  "70.22Z": "Business and other management consultancy activities",
  "70.2A": "Rental of dwellings",
  "70.2B": "Rental of land",
  "70.2C": "Rental of other real estate",
  "70.3": "Real estate activities on a fee or contract basis",
  "70.3A": "Real estate agencies",
  "70.3C": "Management of residential buildings",
  "70.3D": "Management of other real estate",
  "70.3E": "Legal support for asset management",
  "71": "Architectural and engineering activities; technical testing and analysis",
  "71.1": "Architectural and engineering activities and related technical consultancy",
  "71.11": "Architectural activities",
  "71.11Z": "Architectural activities",
  "71.12": "Engineering activities and related technical consultancy",
  "71.12A": "Activities of surveyors",
  "71.12B": "Engineering, technical studies",
  "71.1A": "Short-term rental of motor vehicles",
  "71.1B": "Long-term rental of motor vehicles",
  "71.2": "Technical testing and analysis",
  "71.20": "Technical testing and analysis",
  "71.20A": "Automotive technical inspection",
  "71.20B": "Technical analysis, testing and inspection",
  "71.2A": "Rental of other land transport equipment",
  "71.2C": "Rental of water transport equipment",
  "71.2E": "Rental of air transport equipment",
  "71.3": "Rental of machinery and equipment",
  "71.3A": "Rental of agricultural machinery",
  "71.3C": "Rental of construction machinery and equipment",
  "71.3E": "Rental of office machinery and IT equipment",
  "71.3G": "Rental of various machinery and equipment",
  "71.4": "Rental of personal and household goods",
  "71.4A": "Rental of linen",
  "71.4B": "Rental of other personal and household goods",
  "72": "Scientific research and development",
  "72.1": "Research and experimental development on natural sciences and engineering",
  "72.11": "Research and experimental development on biotechnology",
  "72.11Z": "Research and experimental development on biotechnology",
  "72.19": "Research and experimental development on other natural sciences and engineering",
  "72.19Z": "Research and experimental development on other natural sciences and engineering",
  "72.1Z": "IT consulting",
  "72.2": "Research and experimental development on social sciences and humanities",
  "72.20": "Research and experimental development on social sciences and humanities",
  "72.20Z": "Research and experimental development on social sciences and humanities",
  "72.2A": "Software publishing (non-customized)",
  "72.2C": "Other software development activities",
  "72.3": "Data processing",
  "72.3Z": "Data processing",
  "72.4": "Database activities",
  "72.4Z": "Database activities",
  "72.5": "Maintenance and repair of office machinery and IT equipment",
  "72.5Z": "Maintenance and repair of office machinery and IT equipment",
  "72.6": "Other IT related activities",
  "72.6Z": "Other IT related activities",
  "73": "Advertising and market research",
  "73.1": "Advertising",
  "73.11": "Advertising agencies",
  "73.11Z": "Advertising agencies",
  "73.12": "Media representation",
  "73.12Z": "Media representation",
  "73.1Z": "Research and development in physical and natural sciences",
  "73.2": "Market research and public opinion polling",
  "73.20": "Market research and public opinion polling",
  "73.20Z": "Market research and public opinion polling",
  "73.2Z": "Research and development in human and social sciences",
  "74": "Other professional, scientific and technical activities",
  "74.1": "Specialised design activities",
  "74.10": "Specialised design activities",
  "74.10Z": "Specialised design activities",
  "74.1A": "Legal activities",
  "74.1C": "Accounting activities",
  "74.1E": "Market research and polling",
  "74.1G": "Business and management consulting",
  "74.1J": "Business administration",
  "74.2": "Photographic activities",
  "74.20": "Photographic activities",
  "74.20Z": "Photographic activities",
  "74.2A": "Architectural activities",
  "74.2B": "Quantity surveyors, land surveyors",
  "74.2C": "Engineering, technical studies",
  "74.3": "Translation and interpretation activities",
  "74.30": "Translation and interpretation activities",
  "74.30Z": "Translation and interpretation activities",
  "74.3A": "Automotive technical inspection",
  "74.3B": "Technical analysis, testing and inspection",
  "74.4": "Advertising",
  "74.4A": "Management of advertising media",
  "74.4B": "Advertising agencies, consulting",
  "74.5": "Employment activities",
  "74.5A": "Selection and provision of personnel",
  "74.5B": "Temporary employment agency activities",
  "74.6": "Investigation and security activities",
  "74.6Z": "Investigation and security activities",
  "74.7": "Cleaning activities",
  "74.7Z": "Cleaning activities",
  "74.8": "Other business support service activities n.e.c.",
  "74.8A": "Photographic studios and other photographic activities",
  "74.8B": "Technical laboratories for development and printing",
  "74.8D": "Packaging activities on a fee or contract basis",
  "74.8F": "Secretarial and translation activities",
  "74.8G": "Mailing activities",
  "74.8H": "Call centres",
  "74.8J": "Organisation of trade fairs and shows",
  "74.8K": "Ancillary production services",
  "74.9": "Other professional, scientific and technical activities n.e.c.",
  "74.90": "Other professional, scientific and technical activities n.e.c.",
  "74.90A": "Activities of construction economists",
  "74.90B": "Various specialised scientific and technical activities",
  "75": "Veterinary activities",
  "75.0": "Veterinary activities",
  "75.00": "Veterinary activities",
  "75.00Z": "Veterinary activities",
  "75.1": "Public administration activities",
  "75.1A": "General public administration",
  "75.1C": "Supervision of social activities",
  "75.1E": "Supervision of economic activities",
  "75.1G": "Support activities for administrations",
  "75.2": "Public prerogative services",
  "75.2A": "Foreign affairs",
  "75.2C": "Defense",
  "75.2E": "Justice",
  "75.2G": "Police",
  "75.2J": "Civil protection",
  "75.3": "Compulsory social security activities",
  "75.3A": "General social security activities",
  "75.3B": "Management of supplementary pensions",
  "75.3C": "Social distribution of income",
  "77": "Rental and leasing activities",
  "77.1": "Renting and leasing of motor vehicles",
  "77.11": "Renting and leasing of cars and light motor vehicles",
  "77.11A": "Short-term rental of cars and light motor vehicles",
  "77.11B": "Long-term rental of cars and light motor vehicles",
  "77.12": "Renting and leasing of trucks",
  "77.12Z": "Renting and leasing of trucks",
  "77.2": "Renting and leasing of personal and household goods",
  "77.21": "Renting and leasing of recreational and sports goods",
  "77.21Z": "Renting and leasing of recreational and sports goods",
  "77.22": "Renting of video tapes and disks",
  "77.22Z": "Renting of video tapes and disks",
  "77.29": "Renting and leasing of other personal and household goods",
  "77.29Z": "Renting and leasing of other personal and household goods",
  "77.3": "Renting and leasing of other machinery, equipment and tangible goods",
  "77.31": "Renting and leasing of agricultural machinery and equipment",
  "77.31Z": "Renting and leasing of agricultural machinery and equipment",
  "77.32": "Renting and leasing of construction machinery and equipment",
  "77.32Z": "Renting and leasing of construction machinery and equipment",
  "77.33": "Renting and leasing of office machinery and equipment, including computers",
  "77.33Z": "Renting and leasing of office machinery and equipment, including computers",
  "77.34": "Renting and leasing of water transport equipment",
  "77.34Z": "Renting and leasing of water transport equipment",
  "77.35": "Renting and leasing of air transport equipment",
  "77.35Z": "Renting and leasing of air transport equipment",
  "77.39": "Renting and leasing of other machinery, equipment and tangible goods n.e.c.",
  "77.39Z": "Renting and leasing of other machinery, equipment and tangible goods n.e.c.",
  "77.4": "Leasing of intellectual property and similar products, except copyrighted works",
  "77.40": "Leasing of intellectual property and similar products, except copyrighted works",
  "77.40Z": "Leasing of intellectual property and similar products, except copyrighted works",
  "78": "Employment activities",
  "78.1": "Activities of employment placement agencies",
  "78.10": "Activities of employment placement agencies",
  "78.10Z": "Activities of employment placement agencies",
  "78.2": "Temporary employment agency activities",
  "78.20": "Temporary employment agency activities",
  "78.20Z": "Temporary employment agency activities",
  "78.3": "Other human resources provision",
  "78.30": "Other human resources provision",
  "78.30Z": "Other human resources provision",
  "79": "Travel agency, tour operator and other reservation service activities",
  "79.1": "Travel agency and tour operator activities",
  "79.11": "Travel agency activities",
  "79.11Z": "Travel agency activities",
  "79.12": "Tour operator activities",
  "79.12Z": "Tour operator activities",
  "79.9": "Other reservation service activities and related activities",
  "79.90": "Other reservation service activities and related activities",
  "79.90Z": "Other reservation service activities and related activities",
  "80": "Security and investigation activities",
  "80.1": "Private security activities",
  "80.10": "Private security activities",
  "80.10Z": "Private security activities",
  "80.1Z": "Primary education",
  "80.2": "Security system service activities",
  "80.20": "Security system service activities",
  "80.20Z": "Security system service activities",
  "80.2A": "General secondary education",
  "80.2C": "Technical or vocational secondary education",
  "80.3": "Investigation activities",
  "80.30": "Investigation activities",
  "80.30Z": "Investigation activities",
  "80.3Z": "Higher education",
  "80.4": "Driving school activities and other education activities",
  "80.4A": "Driving schools",
  "80.4C": "Adult education and continuing education",
  "80.4D": "Other education n.e.c.",
  "81": "Services to buildings and landscape activities",
  "81.1": "Combined facilities support activities",
  "81.10": "Combined facilities support activities",
  "81.10Z": "Combined facilities support activities",
  "81.2": "Cleaning activities",
  "81.21": "General cleaning of buildings",
  "81.21Z": "General cleaning of buildings",
  "81.22": "Other building and industrial cleaning activities",
  "81.22Z": "Other building and industrial cleaning activities",
  "81.29": "Other cleaning activities",
  "81.29A": "Disinfection, disinfestation, deratization",
  "81.29B": "Other cleaning activities n.e.c.",
  "81.3": "Landscape service activities",
  "81.30": "Landscape service activities",
  "81.30Z": "Landscape service activities",
  "82": "Office administrative, office support and other business support activities",
  "82.1": "Office administrative and support activities",
  "82.11": "Combined office administrative service activities",
  "82.11Z": "Combined office administrative service activities",
  "82.19": "Photocopying, document preparation and other specialised office support activities",
  "82.19Z": "Photocopying, document preparation and other specialised office support activities",
  "82.2": "Call centre activities",
  "82.20": "Call centre activities",
  "82.20Z": "Call centre activities",
  "82.3": "Organization of conventions and trade shows",
  "82.30": "Organization of conventions and trade shows",
  "82.30Z": "Organization of conventions and trade shows",
  "82.9": "Business support service activities n.e.c.",
  "82.91": "Activities of collection agencies and credit bureaus",
  "82.91Z": "Activities of collection agencies and credit bureaus",
  "82.92": "Packaging activities",
  "82.92Z": "Packaging activities",
  "82.99": "Other business support service activities n.e.c.",
  "82.99Z": "Other business support service activities n.e.c.",
  "84": "Public administration and defence; compulsory social security",
  "84.1": "General public services",
  "84.11": "General public administration activities",
  "84.11Z": "General public administration activities",
  "84.12": "Regulation of the activities of agencies that provide health care, education, cultural services and other social services, excluding social security",
  "84.12Z": "Regulation of the activities of agencies that provide health care, education, cultural services and other social services, excluding social security",
  "84.13": "Regulation of and contribution to the more efficient operation of businesses",
  "84.13Z": "Regulation of and contribution to the more efficient operation of businesses",
  "84.2": "Services to the community as a whole",
  "84.21": "Foreign affairs",
  "84.21Z": "Foreign affairs",
  "84.22": "Defence activities",
  "84.22Z": "Defence activities",
  "84.23": "Justice and judicial activities",
  "84.23Z": "Justice and judicial activities",
  "84.24": "Public order and safety activities",
  "84.24Z": "Public order and safety activities",
  "84.25": "Fire service activities",
  "84.25Z": "Fire service activities",
  "84.3": "Compulsory social security activities",
  "84.30": "Compulsory social security activities",
  "84.30A": "General social security activities",
  "84.30B": "Management of supplementary pensions",
  "84.30C": "Social distribution of income",
  "85": "Education",
  "85.1": "Pre-primary education",
  "85.10": "Pre-primary education",
  "85.10Z": "Pre-primary education",
  "85.1A": "Hospital activities",
  "85.1C": "Medical practice",
  "85.1E": "Dental practice",
  "85.1G": "Activities of paramedical personnel",
  "85.1H": "Care outside a regulated framework",
  "85.1J": "Ambulance services",
  "85.1K": "Medical analysis laboratories",
  "85.1L": "Blood and organ banks",
  "85.2": "Primary education",
  "85.20": "Primary education",
  "85.20Z": "Primary education",
  "85.2Z": "Veterinary activities",
  "85.3": "Secondary education",
  "85.31": "General secondary education",
  "85.31Z": "General secondary education",
  "85.32": "Technical and vocational secondary education",
  "85.32Z": "Technical and vocational secondary education",
  "85.3A": "Accommodation for disabled children",
  "85.3B": "Accommodation for children in difficulty",
  "85.3C": "Accommodation for disabled adults",
  "85.3D": "Accommodation for elderly people",
  "85.3E": "Other social accommodation",
  "85.3G": "Crèches and childcare facilities",
  "85.3H": "Assisted employment, sheltered workshops",
  "85.3J": "Home care services",
  "85.3K": "Other forms of social work",
  "85.4": "Higher education",
  "85.41": "Post-secondary non-tertiary education",
  "85.41Z": "Post-secondary non-tertiary education",
  "85.42": "Higher education",
  "85.42Z": "Higher education",
  "85.5": "Other education",
  "85.51": "Sports and recreation education",
  "85.51Z": "Sports and recreation education",
  "85.52": "Cultural education",
  "85.52Z": "Cultural education",
  "85.53": "Driving school activities",
  "85.53Z": "Driving school activities",
  "85.59": "Other education n.e.c.",
  "85.59A": "Adult continuing education",
  "85.59B": "Other education",
  "85.6": "Educational support activities",
  "85.60": "Educational support activities",
  "85.60Z": "Educational support activities",
  "86": "Human health activities",
  "86.1": "Hospital activities",
  "86.10": "Hospital activities",
  "86.10Z": "Hospital activities",
  "86.2": "Medical and dental practice activities",
  "86.21": "General medical practice activities",
  "86.21Z": "General medical practice activities",
  "86.22": "Specialised medical practice activities",
  "86.22A": "Radiodiagnostic and radiotherapy activities",
  "86.22B": "Surgical activities",
  "86.22C": "Other specialised medical practice activities",
  "86.23": "Dental practice activities",
  "86.23Z": "Dental practice activities",
  "86.9": "Other human health activities",
  "86.90": "Other human health activities",
  "86.90A": "Ambulance services",
  "86.90B": "Medical analysis laboratories",
  "86.90C": "Blood and organ banks",
  "86.90D": "Activities of nurses and midwives",
  "86.90E": "Activities of rehabilitation professionals, prosthetists and podiatrists",
  "86.90F": "Human health activities not elsewhere classified",
  "87": "Residential care activities",
  "87.1": "Residential nursing care facilities",
  "87.10": "Residential nursing care facilities",
  "87.10A": "Residential nursing care facilities for elderly people",
  "87.10B": "Residential nursing care facilities for disabled children",
  "87.10C": "Residential nursing care facilities for disabled adults and other residential nursing care",
  "87.2": "Residential care activities for mental retardation, mental health and substance abuse",
  "87.20": "Residential care activities for mental retardation, mental health and substance abuse",
  "87.20A": "Residential care for mentally disabled and mentally ill persons",
  "87.20B": "Residential care for substance abusers",
  "87.3": "Residential care activities for the elderly and disabled",
  "87.30": "Residential care activities for the elderly and disabled",
  "87.30A": "Residential care for elderly people",
  "87.30B": "Residential care for physically disabled people",
  "87.9": "Other residential care activities",
  "87.90": "Other residential care activities",
  "87.90A": "Residential care for children in difficulty",
  "87.90B": "Other residential care for adults and families in difficulty and other social accommodation",
  "88": "Social work activities without accommodation",
  "88.1": "Social work activities without accommodation for the elderly and disabled",
  "88.10": "Social work activities without accommodation for the elderly and disabled",
  "88.10A": "Home help services",
  "88.10B": "Day care or accompanying services without accommodation for disabled adults or elderly people",
  "88.10C": "Assisted employment",
  "88.9": "Other social work activities without accommodation",
  "88.91": "Social work activities without accommodation for young children",
  "88.91A": "Childcare services",
  "88.91B": "Day care or accompanying services without accommodation for disabled children",
  "88.99": "Other social work activities without accommodation n.e.c.",
  "88.99A": "Other day care or accompanying services without accommodation for children and adolescents",
  "88.99B": "Social work activities without accommodation n.e.c.",
  "90": "Creative, arts and entertainment activities",
  "90.0": "Performing arts, artistic creation and management of entertainment venues",
  "90.01": "Performing arts",
  "90.01Z": "Performing arts",
  "90.02": "Support activities to performing arts",
  "90.02Z": "Support activities to performing arts",
  "90.03": "Artistic creation",
  "90.03A": "Visual arts creation",
  "90.03B": "Other artistic creation",
  "90.04": "Operation of arts facilities",
  "90.04Z": "Operation of arts facilities",
  "90.0A": "Collection and treatment of waste water",
  "90.0B": "Household waste collection and treatment",
  "90.0E": "Other solid waste treatment",
  "90.0G": "Other sewerage and street cleaning works",
  "91": "Libraries, archives, museums and other cultural activities",
  "91.0": "Libraries, archives, museums and other cultural activities",
  "91.01": "Library and archive activities",
  "91.01Z": "Library and archive activities",
  "91.02": "Museums activities",
  "91.02Z": "Museums activities",
  "91.03": "Operation of historical sites and buildings and similar visitor attractions",
  "91.03Z": "Operation of historical sites and buildings and similar visitor attractions",
  "91.04": "Botanical and zoological gardens and nature reserves activities",
  "91.04Z": "Botanical and zoological gardens and nature reserves activities",
  "91.1": "Activities of business, employers and professional membership organizations",
  "91.1A": "Employers' and consular organizations",
  "91.1C": "Professional organizations",
  "91.2": "Activities of trade unions",
  "91.2Z": "Activities of trade unions",
  "91.3": "Activities of other membership organisations n.e.c.",
  "91.3A": "Religious organisations",
  "91.3C": "Political organizations",
  "91.3E": "Membership organizations n.e.c.",
  "92": "Gambling and betting activities",
  "92.0": "Gambling and betting activities",
  "92.00": "Gambling and betting activities",
  "92.00Z": "Gambling and betting activities",
  "92.1": "Motion picture and video activities",
  "92.1A": "Production of films for television",
  "92.1B": "Production of institutional and advertising films",
  "92.1C": "Production of films for cinema",
  "92.1D": "Technical services for cinema and television",
  "92.1F": "Distribution of cinematographic films",
  "92.1G": "Video publishing and distribution",
  "92.1J": "Motion picture projection",
  "92.2": "Radio and television activities",
  "92.2A": "Radio activities",
  "92.2B": "Television program production",
  "92.2D": "General interest channel publishing",
  "92.2E": "Thematic channel publishing",
  "92.2F": "Distribution of radio and television program packages",
  "92.3": "Other artistic and entertainment activities",
  "92.3A": "Artistic activities",
  "92.3B": "Ancillary services to shows",
  "92.3D": "Management of performance venues",
  "92.3F": "Fairground rides and amusement parks",
  "92.3K": "Various entertainment activities",
  "92.4": "News agency activities",
  "92.4Z": "News agency activities",
  "92.5": "Other cultural activities",
  "92.5A": "Library management",
  "92.5C": "Management of cultural heritage",
  "92.5E": "Management of natural heritage",
  "92.6": "Sports activities",
  "92.6A": "Operation of sports facilities",
  "92.6C": "Other sports activities",
  "92.7": "Recreational activities",
  "92.7A": "Gambling and betting activities",
  "92.7C": "Other recreational activities",
  "93": "Other personal service activities",
  "93.0": "Other personal service activities",
  "93.0A": "Industrial laundry and dry cleaning services",
  "93.0B": "Retail laundry and dry cleaning services",
  "93.0D": "Hairdressing",
  "93.0E": "Beauty care",
  "93.0G": "Care for the deceased",
  "93.0H": "Funeral services",
  "93.0K": "Thermal and thalassotherapy activities",
  "93.0L": "Other body care services",
  "93.0N": "Other personal services n.e.c.",
  "93.1": "Sports activities",
  "93.11": "Operation of sports facilities",
  "93.11Z": "Operation of sports facilities",
  "93.12": "Activities of sports clubs",
  "93.12Z": "Activities of sports clubs",
  "93.13": "Fitness facilities",
  "93.13Z": "Fitness facilities",
  "93.19": "Other sports activities",
  "93.19Z": "Other sports activities",
  "93.2": "Amusement and recreation activities",
  "93.21": "Activities of amusement parks and theme parks",
  "93.21Z": "Activities of amusement parks and theme parks",
  "93.29": "Other amusement and recreation activities",
  "93.29Z": "Other amusement and recreation activities",
  "94": "Activities of membership organisations",
  "94.1": "Activities of business, employers and professional membership organisations",
  "94.11": "Activities of business and employers' organisations",
  "94.11Z": "Activities of business and employers' organisations",
  "94.12": "Activities of professional membership organisations",
  "94.12Z": "Activities of professional membership organisations",
  "94.2": "Activities of trade unions",
  "94.20": "Activities of trade unions",
  "94.20Z": "Activities of trade unions",
  "94.9": "Activities of other membership organisations",
  "94.91": "Activities of religious organisations",
  "94.91Z": "Activities of religious organisations",
  "94.92": "Activities of political organisations",
  "94.92Z": "Activities of political organisations",
  "94.99": "Activities of other membership organisations n.e.c.",
  "94.99Z": "Other membership organisations n.e.c.",
  "95": "Repair of computers and personal and household goods",
  "95.0": "Activities of households as employers of domestic personnel",
  "95.0Z": "Activities of households as employers of domestic personnel",
  "95.1": "Repair of computers and communication equipment",
  "95.11": "Repair of computers and peripheral equipment",
  "95.11Z": "Repair of computers and peripheral equipment",
  "95.12": "Repair of communication equipment",
  "95.12Z": "Repair of communication equipment",
  "95.2": "Repair of personal and household goods",
  "95.21": "Repair of consumer electronics",
  "95.21Z": "Repair of consumer electronics",
  "95.22": "Repair of household appliances and home and garden equipment",
  "95.22Z": "Repair of household appliances and home and garden equipment",
  "95.23": "Repair of footwear and leather goods",
  "95.23Z": "Repair of footwear and leather goods",
  "95.24": "Repair of furniture and home furnishings",
  "95.24Z": "Repair of furniture and home furnishings",
  "95.25": "Repair of watches, clocks and jewellery",
  "95.25Z": "Repair of watches, clocks and jewellery",
  "95.29": "Repair of other personal and household goods",
  "95.29Z": "Repair of other personal and household goods",
  "96": "Other personal service activities",
  "96.0": "Activities of households as producers of goods for own use",
  "96.01": "Washing and (dry-) cleaning of textile and fur products",
  "96.01A": "Industrial laundry and dry cleaning services",
  "96.01B": "Retail laundry and dry cleaning services",
  "96.02": "Hairdressing and other beauty treatment",
  "96.02A": "Hairdressing",
  "96.02B": "Beauty care",
  "96.03": "Funeral and related activities",
  "96.03Z": "Funeral and related activities",
  "96.04": "Physical well-being activities",
  "96.04Z": "Physical well-being activities",
  "96.09": "Other personal service activities n.e.c.",
  "96.09Z": "Other personal service activities n.e.c.",
  "96.0Z": "Activities of households as producers of goods for own use",
  "97": "Activities of households as producers of services for own use",
  "97.0": "Activities of households as producers of services for own use",
  "97.00": "Activities of households as employers of domestic personnel",
  "97.00Z": "Activities of households as employers of domestic personnel",
  "97.0Z": "Activities of households as producers of services for own use",
  "98": "Activities of households as producers of goods and services for own use",
  "98.1": "Activities of households as producers of goods for own use",
  "98.10": "Activities of households as producers of goods for own use",
  "98.10Z": "Activities of households as producers of goods for own use",
  "98.2": "Activities of households as producers of services for own use",
  "98.20": "Activities of households as producers of services for own use",
  "98.20Z": "Activities of households as producers of services for own use",
  "99": "Activities of extraterritorial organisations and bodies",
  "99.0": "Activities of extraterritorial organisations and bodies",
  "99.00": "Activities of extraterritorial organisations and bodies",
  "99.00Z": "Activities of extraterritorial organisations and bodies",
  "99.0Z": "Activities of extraterritorial organisations and bodies",
  "A": "Agriculture, forestry and fishing",
  "AA": "Agriculture, forestry and fishing",
  "B": "Mining and quarrying",
  "BA": "Mining and quarrying",
  "C": "Manufacturing",
  "CA": "Manufacture of food products",
  "CB": "Manufacture of beverages",
  "Commerce de gros de bois et de matériaux de construction": "Wholesale of wood and construction materials",
  "D": "Electricity, gas, steam and air conditioning supply",
  "DA": "Manufacture of food products",
  "DB": "Manufacture of textiles and wearing apparel",
  "DC": "Manufacture of leather and related products",
  "DD": "Manufacture of wood and of products of wood and cork, except furniture; manufacture of articles of straw and plaiting materials",
  "DE": "Manufacture of paper and paper products; Printing and reproduction of recorded media",
  "DF": "Manufacture of coke and refined petroleum products; Manufacture of nuclear fuel",
  "DG": "Manufacture of chemicals and chemical products",
  "DH": "Manufacture of rubber and plastic products",
  "DI": "Manufacture of other non-metallic mineral products",
  "DJ": "Manufacture of basic metals; Manufacture of fabricated metal products, except machinery and equipment",
  "DK": "Manufacture of machinery and equipment n.e.c.",
  "DL": "Manufacture of computer, electronic and optical products; Manufacture of electrical equipment",
  "DM": "Manufacture of motor vehicles, trailers and semi-trailers; Manufacture of other transport equipment",
  "DN": "Manufacture of furniture; Other manufacturing",
  "E": "Water supply; sewerage, waste management and remediation activities",
  "EA": "Water supply; sewerage, waste management and remediation activities",
  "F": "Construction",
  "FA": "Construction",
  "G": "Wholesale and retail trade; repair of motor vehicles and motorcycles",
  "GA": "Wholesale and retail trade; repair of motor vehicles and motorcycles",
  "H": "Transportation and storage",
  "HA": "Accommodation and food service activities",
  "I": "Accommodation and food service activities",
  "IA": "Accommodation and food service activities",
  "J": "Information and communication",
  "JA": "Financial and insurance activities",
  "K": "Financial and insurance activities",
  "KA": "Real estate activities",
  "L": "Real estate activities",
  "LA": "Public administration and defence; compulsory social security",
  "M": "Professional, scientific and technical activities",
  "MA": "Education",
  "N": "Administrative and support service activities",
  "NA": "Human health and social work activities",
  "O": "Public administration and defence; compulsory social security",
  "OA": "Arts, entertainment and recreation",
  "P": "Education",
  "PA": "Activities of households as employers; undifferentiated goods- and services-producing activities of households for own use",
  "Q": "Human health and social work activities",
  "QA": "Activities of extraterritorial organisations and bodies",
} as const;